import React, { useEffect, useState, useRef } from "react";
import { GoSearch } from "react-icons/go";
import axios from "../../axios-interceptor"
import { FaSearch } from "react-icons/fa";
import Spinner from 'react-bootstrap/Spinner';
import { Stack } from 'react-bootstrap'
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useDispatch, useSelector } from 'react-redux';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import {
    commercialHeadAddNewFMSContract, commercialHeadUpdateDraftContract,
    commercialHeadAddNewContractDelete, commercialHeadSubmitContract,
    commercialHeadGetAllMeters, commercialHeadGetDepartments, commercialHeadGetUtilityRates,
    commercialEditCompleteContract, commercialHeadUploadDocument, commercialHeadGetBillingEntities, commercialHeadGetDocuments,
    handleDocumentLoaderTrue, handleDocumentLoaderFalse, handlePaginationLoaderTrue,
    commercialHeadUpdateFMSContract, PUT_CH_ADD_NEW_FMSCONTRACT_SUCCESS,
    commercialHeadGetFmsContractsForDropdown, clearCommercialHeadDocumentContent,
    SET_ERROR_FALSE,
    UPDATE_CH_DRAFT_CONTRACT_SUCCESS,
    UPDATE_COMPLETE_CONTRACT_SUCCESS,
    PUT_CH_SUBMIT_CONTRACT_SUCCESS,
    commercialHeadGetAllFacilitiesForNav
} from '../../Redux/Actions/Actions'
import { commercialHeadGetContracts, commercialHeadGetFMSContracts, commercialHeadGetFMSDraftContracts } from "../../Redux/Actions/Actions";
import { commercialHeadGetDraftContracts } from "../../Redux/Actions/Actions";
import Loader from "../Reusable_Components/loader";
import { IoMdInformationCircleOutline } from "react-icons/io";
import Alert from 'react-bootstrap/Alert';
import { base_url } from "../../utilities";
import UploadComponent from '../Reusable_Components/UploadComponent';

import { MdInfoOutline } from "react-icons/md";
import NavBarTop from "../Reusable_Components/NavBarTop";
import LeftNavBar from "../Reusable_Components/LeftNavBar";
import AlertPopUp from "../Reusable_Components/Alert";
import { GrView } from "react-icons/gr";
import Pagination from "../Reusable_Components/Pagination";
import { RECORDS_PER_PAGE } from "../../Config";
import { set } from "date-fns";
import {
    formatCurrencyBasedOnRegion, timeElapsed, validateValue,formatNumericInput, formatNumericParseIntInput, 
    validEmailCheck, formatNumericparseFloatInput, processAndValidateEmail,limitCurrencyAmount,
    licenseFeeDateValidationByStartDateEndDate,
    eleminateSpecialCharactersAtStartOfInputField, eleminateSpacesAtStartOfInputField,
    ContractsNameAndNumber, validateGstNumber,
    checkUniqueness, handleKeyPressForGst
} from "../Reusable_Components/ReusableFunctions";

import { MdErrorOutline } from 'react-icons/md';
import Footer from "../Login/Footer.jsx";
import { useLocation } from "react-router-dom";
import { FaSort, FaRegEdit } from 'react-icons/fa';
import { MdPersonAddAlt1 } from "react-icons/md";


export default function CommercialHeadFMS() {

    const location = useLocation()
    const { props } = location.state || {};

    useEffect(() => {

        const details = props
        const contractDetails = {
            "contract_id": details?.entity_details?.contract_id,
        }
        if (contractDetails["contract_id"]) {
            setIsLoading(true)
            viewSelectedContract(contractDetails)
        }
    }, [props])

    const [cinNumber, setCinNumber] = useState("");
    const [gracePeriod, setGracePeriod] = useState(0);
    const documentLoaderTrigger = useSelector(state => state.documentLoaderTrigger);
    const todayDate = new Date();
    let currentDay = todayDate.getDate();
    let currentMonth = todayDate.getMonth() + 1;
    let currentYear = todayDate.getFullYear();
    const finalTodayDate = new Date(currentYear + "-" + currentMonth + "-" + currentDay)
    const draftcontractUpdated = useSelector((state) => state.updateFMSContract);
    const commercialHeadUploadDocumentList = useSelector((state) => state.commercialHeadUploadDocumentList)
    const commercialHeadGetDocumentsForContract = useSelector((state) => state.commercialHeadGetDocumentsForContract)
    const fmsContractsDropdown = useSelector((state) => state.fmscontractsForDropdown)
    const contractApiLoader = useSelector((state) => state.contractApiLoader)
    const fmsContactsAfterSave = useSelector((state) => state.fmsContacts)
    const [documentList, setDocumentList] = useState([])
    const paginationLoader = useSelector((state) => state.paginationLoader)
    const [contractIdforReference, setcontractIdforReference] = useState('')
    const [statusFilter, setStatusFilter] = useState('active');
    const [dateError, setDateError] = useState('')

    useEffect(() => {
        let documentListTemp = [...documentList];
        commercialHeadUploadDocumentList?.forEach(item => {
            if (!documentListTemp.includes(item)) {
                documentListTemp.push(item);
            }
        });
        setDocumentList([...documentListTemp]);
    }, [commercialHeadUploadDocumentList])

    const steps = [
        {
            name: "1. Basic Information",
            description: "Company Details and Contacts"
        },
        {
            name: "2. Address Information",
            description: "Billing Address and Shipping Address"
        },
        {
            name: "3. Contract Information",
            description: "Contract Details and FMS Rates"
        },
    ]
    const allContracts = useSelector((state) => state.contractsFMS?.data);
    const alldraftContracts = useSelector((state) => state.draftContracts?.data)

    const totalRecordsAc = useSelector((state) => state.contractsFMS?.info?.total_no_of_records);
    const totalRecordsDc = useSelector((state) => state.draftContracts?.info?.total_no_of_records);

    const currentPaginationPageAc = useSelector((state) => state.contractsFMS?.info?.page_number);
    const currentPaginationPageDc = useSelector((state) => state.draftContracts?.info?.page_number);


    const allMeters = useSelector((state) => state.allMeters)
    const allDepartments = useSelector((state) => state.allDepartments)
    const utilityRates = useSelector((state) => state.utilityRates)
    const meterTypesList = allMeters?.reduce((acc, curr) => {
        if (curr.meter_type && !acc.includes(curr.meter_type)) {
            acc.push(curr.meter_type);
        }
        return acc;
    }, []);


    const [isContractNumberValid, setIsContractNumberValid] = useState([]);
    const [duplicateContractNumberError, setDuplicateContractNumberError] = useState(false);
    const [duplicateContractNameError, setDuplicateContractNameError] = useState(false);
    const [selectedContractName, setSelectedContractName] = useState('');
    const [selectedContractNumber, setSelectedContractNumber] = useState('');



    const [contractsList, setContractsList] = useState([])
    const [tableLoader, setTableLoader] = useState(true)
    const [gstLoader, setGstLoader] = useState(false);
    const newContractId = useSelector((state) => state.newFmsContractId);
    const [selectedContract, setSelectedContract] = useState(false)
    const [popOverPosition, setPopOverPosition] = useState('bottom')
    const [contractType, setContractType] = useState("all");
    const [searchText, setSearchText] = useState("")
    const [filteredContracts, setFilteredContracts] = useState([]);
    const [viewClicked, setViewClicked] = useState(false)
    const [companyNameFilter, setCompanyNameFilter] = useState(false)
    const [isLoading, setIsLoading] = useState(false);
    const isSubmittedContract = useSelector((state) => state.submittedContract);
    const isSubmittedCompleteContract = useSelector((state) => state.submittedCompleteContract);
    const [showSuccess, setShowSuccess] = useState(false);
    const [contractStartDate, setContractStartDate] = useState('');
    const [contractEndDate, setContractEndDate] = useState('');
    const [alertShow, setAlertShow] = useState(false)
    const [alertType, setAlertType] = useState('')
    const [alertMessage, setAlertMessage] = useState('')
    const [alertValue, setAlertValue] = useState('')
    const [alertButtons, setAlertButtons] = useState([])
    const [saveasDraftClicked, setSaveasDraftClicked] = useState(false)

    const error = useSelector((state) => state.error);
    const [errorValue, setErrorValue] = useState(null)
    const [finalReadingError, setFinalReadingError] = useState(false)
    const [finalDgReadingError, setFinalDgReadingError] = useState(false)

    const [showCloseConfirmationModal, setShowCloseConfirmationModal] = useState(false);
    const handleShowCloseConfirmationModal = () => setShowCloseConfirmationModal(true);
    const handleCloseCloseConfirmationModal = () => setShowCloseConfirmationModal(false);

    const [slfTableError, setSlfTableError] = useState(false)
    const [billingEntity, setBillingEntity] = useState('')
    const [uniqueFMSContractNames, setUniqueFMSContractNames] = useState([])
    const [uniqueFMSContractNumbers, setUniqueFMSContractNumbers] = useState([])


    const handleCloseProceed = () => {
        // saveasDraft();
        dispatch(clearCommercialHeadDocumentContent())
        setShowCloseConfirmationModal(false);
        closeClicked();
    };


    // ========================error useeffect =================
    useEffect(() => {
        setErrorValue(error?.response?.data.message);
        if (error?.response?.data.message) {
            setAlertShow(true)
            setAlertType('error')
            setAlertMessage('Error')
            setAlertValue(error?.response?.data.message)
            setAlertButtons([{
                name: 'Close', action: () => {
                    dispatch({
                        type: SET_ERROR_FALSE,
                        payload: null
                    })
                    setAlertShow(false)
                }
            }])
        }
        setIsLoading(false);
    }, [error])

    useEffect(() => {
        if (draftcontractUpdated === 'success' && saveasDraftClicked) {
            setAlertShow(true)
            setAlertType('question')
            setAlertMessage('')
            setAlertValue(<>
                {
                    selectedDraftContract ?
                        <p className="mb-3">Contract <b>{selectedDraftContract.contract_name}</b> has been successfully updated.</p>
                        :

                        <p className="mb-3">Contract <b>{contractName}</b> has been successfully created.</p>
                }
            </>
            )


            setAlertButtons([
                {
                    name: 'View Contract', variant: 'outline-secondary', action: () => {
                        setAlertShow(false)
                        dispatch({
                            type: UPDATE_CH_DRAFT_CONTRACT_SUCCESS,
                            payload: null,
                        })
                        setSaveasDraftClicked(false)
                        setViewClicked(true)
                        viewSelectedContract({
                            'contract_id': contractIdforReference
                        })
                        // handleCloseModal()
                    }
                },
                {
                    name: 'Close', action: () => {
                        setAlertShow(false)
                        setSaveasDraftClicked(false)
                        handleCloseModal()
                        dispatch({
                            type: UPDATE_CH_DRAFT_CONTRACT_SUCCESS,
                            payload: null,
                        })
                    }
                },

            ])

        }
        setIsLoading(false)

    }, [draftcontractUpdated])

    useEffect(() => {
        if (fmsContactsAfterSave !== null) {
            setListOfContacts(fmsContactsAfterSave)
        }
    }, [fmsContactsAfterSave])

    useEffect(() => {
        if (fmsContractsDropdown !== null && fmsContractsDropdown.length !== 0) {
            const data = fmsContractsDropdown
            const fmsContractNameArray = []
            const fmsContractNumberArray = []
            data?.map(contract => {
                fmsContractNameArray.push(contract?.contract_name)
                fmsContractNumberArray.push(contract?.contract_number)
            })
            setUniqueFMSContractNames([...fmsContractNameArray])
            setUniqueFMSContractNumbers([...fmsContractNumberArray])
        }
    }, [fmsContractsDropdown])


    useEffect(() => {
        if (isSubmittedContract === 'success') {
            setAlertShow(true)
            setAlertType('question')
            setAlertMessage('')
            setAlertValue(<>
                {
                    selectedDraftContract ?
                        <p className="mb-3">Contract <b>{selectedDraftContract.contract_name}</b> has been successfully updated.</p>
                        :

                        <p className="mb-3">Contract <b>{contractName}</b> has been successfully created.</p>
                }
            </>)
            setAlertButtons([
                {
                    name: 'View Contract', variant: 'outline-secondary', action: () => {
                        setAlertShow(false)
                        dispatch({
                            type: UPDATE_COMPLETE_CONTRACT_SUCCESS,
                            payload: null,
                        })
                        setViewClicked(true)
                        viewSelectedContract({
                            'contract_id': contractIdforReference
                        })
                    }
                },
                {
                    name: 'Close', action: () => {
                        setAlertShow(false)
                        handleCloseModal()
                        dispatch({
                            type: UPDATE_COMPLETE_CONTRACT_SUCCESS,
                            payload: null,
                        })
                    }
                },
            ])
        }
        setIsLoading(false)
    }, [isSubmittedContract])

    useEffect(() => {
        if (isSubmittedCompleteContract?.status === 'success') {
            setAlertShow(true)
            setAlertType('question')
            setAlertMessage('')
            setAlertValue(<>
                <p className="mb-3">Contract <b>{selectedDraftContract.contract_name}</b> has been successfully submitted.</p>

            </>)
            setAlertButtons([
                {
                    name: 'View Contract', variant: 'outline-secondary', action: () => {
                        setAlertShow(false)
                        dispatch({
                            type: PUT_CH_SUBMIT_CONTRACT_SUCCESS,
                            payload: null,
                        })
                        setViewClicked(true)
                        viewSelectedContract({
                            'contract_id': isSubmittedCompleteContract?.data?.contract_id
                        })
                    }
                },
                {
                    name: 'Close', action: () => {
                        setAlertShow(false)
                        handleCloseModal()
                        dispatch({
                            type: PUT_CH_SUBMIT_CONTRACT_SUCCESS,
                            payload: null,
                        })
                    }
                },

            ])
        }
        setIsLoading(false)
    }, [isSubmittedCompleteContract])
    // ===============================
    const [licenseTableBodyRows, setLicenseTableBodyRows] = useState([{
        serial_number: 1,
        area_in_sqft: "",
        cost_per_unit: "",
        rate_start_date: contractStartDate,
        rate_end_date: contractEndDate,
        license_fee: ""
    }])

    const handleAddLicenseFeeRow = () => {
        let date = ""
        if (licenseTableBodyRows.length >= 1) {
            if (licenseTableBodyRows[licenseTableBodyRows.length - 1]?.rate_end_date) {
                date = new Date(licenseTableBodyRows[licenseTableBodyRows.length - 1]?.rate_end_date);
                date.setDate(date.getDate() + 1);
                date = date.toISOString('yyyy-mm-dd').slice(0, 10);
            }

        }

        let newRow = [...licenseTableBodyRows, {
            serial_number: licenseTableBodyRows.length + 1,
            area_in_sqft: "",
            cost_per_unit: "",
            rate_start_date: date,
            rate_end_date: contractEndDate,
            license_fee: 0.0
        }];
        setLicenseTableBodyRows([...newRow])
        setSlfTableError(licenseFeeDateValidationByStartDateEndDate(newRow, contractStartDate, contractEndDate))

    }

    const handleRemoveLicenseFeeRow = (index) => {
        let newList = [...licenseTableBodyRows]
        newList.splice(index, 1);
        // if(newList.length === 1){
        //     newList[0].rate_end_date = contractEndDate
        // }
        setLicenseTableBodyRows([...newList])
        setSlfTableError(licenseFeeDateValidationByStartDateEndDate(newList, contractStartDate, contractEndDate))

    }

    const dispatch = useDispatch();
    const [contractNumbers, setContractNumbers] = useState([]); // List of contract numbers
    const [contractNames, setContractNames] = useState([]); // List of contract names

    const billingEntities = useSelector((state) => state.billingEntities);

    useEffect(() => {
        dispatch(commercialHeadGetFMSContracts({ facility_id: localStorage.getItem("selected_facility_id"), status: statusFilter, search_text: searchText, items_per_page: RECORDS_PER_PAGE, page_number: 1 }));

        dispatch(commercialHeadGetAllMeters({
            request_type: "dropdown",
            filter_condition: {
                facility_id: localStorage.getItem("selected_facility_id"),
                is_in_use: 0,
                is_working: 1
            }
        }));
        dispatch(commercialHeadGetDepartments());
        dispatch(commercialHeadGetUtilityRates(localStorage.getItem("selected_facility_id")));
        dispatch(commercialHeadGetBillingEntities());
        dispatch(commercialHeadGetFmsContractsForDropdown())
        dispatch(commercialHeadGetAllFacilitiesForNav())
    }, [dispatch]);



    const handleContractNumberChange = (event) => {
        let input = event.target.value;
        input = input.replace(/[^a-zA-Z0-9./\\\-_]+/g, '');;
        const lengthValid = input.length === 0 || input.length >= 3 && input.length <= 200;

        const isReplicaValid = input === selectedContractNumber;

        setContractNumber(input); // Changed from value to input
        setIsContractNumberValid(lengthValid);

        // const isDuplicateNumber = contractNumbers.some((contract_number) => contract_number === input);
        const notUnique = checkUniqueness(uniqueFMSContractNumbers, selectedContractNumber, input)
        setDuplicateContractNumberError(notUnique);
    };

    const handleContractNameChange = (event) => {
        let value = event.target.value;
        value = value.trim();
        if (validateValue(value.charAt(0))) {
            setContractName(value);
            const lengthValid = value.length >= 3 && value.length <= 200;
            setIsContractNameValid(lengthValid);

            // const isReplicaValid = value.toLowerCase() === selectedContractName.toLowerCase();
            // const isDuplicateName = contractNames.some((contract_name) => contract_name.toLowerCase() === value.toLowerCase());
            const notUnique = checkUniqueness(uniqueFMSContractNames, selectedContractName, value)
            setDuplicateContractNameError(notUnique);
        } else {
            event.target.value = contractName;
        }
    };

    const searchFunc = (value) => {
        if (validateValue(value)) {
            setSearchText(value);
        }
    };

    useEffect(() => {
        if (contractType === 'all') {
            setFilteredContracts(allContracts);
            setContractsList(allContracts)
        }
        else {
            setFilteredContracts(alldraftContracts);
            setContractsList(alldraftContracts)
        }
        if (allContracts !== null && alldraftContracts !== null) {
            const myTimeout = setTimeout(() => {
                setTableLoader(false)
            }, 500);
        }
        setIsLoading(false)

    }, [contractType, allContracts, alldraftContracts])

    const GstLoader = () => {
        return <Spinner style={{ height: "18px", width: "18px" }} animation="border" variant="light" />
    }


    const LoaderSpinner = () => {
        return <Spinner animation="border" variant="secondary" />
    }

    const [showDraftModal, setShowDraftModal] = useState(false);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);

    const sameAsRegisteredAddress = () => {
        setBillingStreetAddress(registeredStreetAddress)
        setBillingStreetAddressLane2(registeredStreetAddressLane2)
        setBillingCity(registeredCity)
        setBillingStateProvince(registeredStateProvince)
        setBillingPostalCode(registeredPostalCode)
    }

    const sameAsBillingAddress = () => {
        setShippingStreetAddress(billingStreetAddress)
        setShippingStreetAddressLane2(billingStreetAddressLane2)
        setShippingCity(billingCity)
        setShippingStateProvince(billingStateProvince)
        setShippingPostalCode(billingPostalCode)
    }
    const handleCloseDraftModal = () => {
        setShowDraftModal(false);
    };
    const handleCloseConfirmationModal = () => {
        setShowConfirmationModal(false);
        setSaveasDraftClicked(false)
    };
    const handleSaveAsDraftConfirmation = () => {
        dispatch(clearCommercialHeadDocumentContent())
        setShowConfirmationModal(false);
    };
    const handleSaveAsDraftClick = () => {
        setShowConfirmationModal(true);
    };

    const handleCloseModal = () => {
        dispatch(clearCommercialHeadDocumentContent())
        setCurrentPage(1)
        backfunction()
        clearValidationErrors()
        searchFunc(searchText)
        // handleApplyFilter()
        backPagination()
        setShowDraftModal(false);
        dispatch({
            type: PUT_CH_ADD_NEW_FMSCONTRACT_SUCCESS,
            payload: null,
        })
    }

    const handleEmailUpdateChange = (e, index) => {
        const input = e.target.value;
        const currentEmail = listOfContacts[index]?.email || '';
        const { processedInput, isValid } = processAndValidateEmail(input, currentEmail);

        const updatedContacts = [...listOfContacts];
        const updatedContactsValidation = [...listOfContactsValidation];

        updatedContacts[index] = { ...updatedContacts[index], email: processedInput };
        updatedContactsValidation[index] = { ...updatedContactsValidation[index], isValidEmail: isValid };

        setListOfContacts(updatedContacts);
        setListOfContactsValidation(updatedContactsValidation);
    };

    const handleSubmit = () => {
        let objContract = {
            "contract_id": selectedDraftContract.contract_id,
            "contract_name": contractName,
            "contract_status": contractStatus,
            "primary_contact_name": contactName,
            "primary_contact_phone_number": phoneNumber,
            "billing_entity": billingEntity,
            "primary_contact_email": email,
            "company_name": companyName,
            "pan_number": panName,
            "gst_number": gstNumber,
            "cin": cinNumber,
            "registered_address": {
                "street_address_1": registeredStreetAddress,
                "street_address_2": registeredStreetAddressLane2,
                "city": registeredCity,
                "door_number": 'door2',
                "country": "India",
                "state": registeredStateProvince,
                "postal_code": registeredPostalCode.toString(),
                "address_type": 'Work'
            },
            "billing_address": {
                "street_address_1": billingStreetAddress,
                "street_address_2": billingStreetAddressLane2,
                "door_number": 'door1',
                "country": "India",
                "city": billingCity,
                "state": billingStateProvince,
                "postal_code": billingPostalCode.toString(),
            },
            "shipping_address": {
                "street_address_1": shippingStreetAddress,
                "street_address_2": shippingStreetAddressLane2,
                "door_number": 'door1',
                "country": "India",
                "city": shippingCity,
                "state": shippingStateProvince,
                "postal_code": shippingPostalCode.toString(),
            },
            "contacts": listOfContacts,

            // ================
            "contract_number": contractNumber,
            "contract_start_date": contractStartDate,
            "contract_end_date": contractEndDate,
            "contract_billing_type": contractBillingType,
            "notification_before": expireNotification,
            "grace_period": gracePeriod,

            "verification_from_portal": 0, //check again

            "facility_id": selectedDraftContract.facility_id, // check again
            "space_name": spaceName,
            "terms_and_conditions": termsAndConditions,
            "license_fee": 15000,
            "fms_rates": licenseTableBodyRows,
        }
        setSaveasDraftClicked(true)
        setcontractIdforReference(selectedDraftContract.contract_id)
        dispatch(commercialHeadUpdateFMSContract(objContract))

        setIsLoading(true)
    }


    const saveAndContinue = () => {

        extractContractNameNumber();

        const isDuplicateName = contractNames.some((contract_name) => contract_name.toLowerCase() === contractName.trim().toLowerCase());
        const isReplicaValid = contractName.trim().toLowerCase() === selectedContractName.toLowerCase();
        setDuplicateContractNameError(isDuplicateName && !isReplicaValid);
        setContractName(contractName.trim())
        if (!(isDuplicateName && !isReplicaValid)) {
            if (selectedDraftContract) { // for editing a draft contract
                let objContract = {
                    "contract_id": selectedDraftContract.contract_id,
                    "contract_name": contractName.trim(),
                    "contract_status": contractStatus,
                    "primary_contact_name": contactName,
                    "primary_contact_phone_number": phoneNumber,
                    "primary_contact_email": email,
                    "billing_entity": billingEntity,
                    "company_name": companyName,
                    "pan_number": panName,
                    "gst_number": gstNumber,
                    "cin": cinNumber,
                    "fms_rates": licenseTableBodyRows,
                    "registered_address": {
                        "street_address_1": registeredStreetAddress,
                        "street_address_2": registeredStreetAddressLane2,
                        "city": registeredCity,
                        "door_number": 'door1',
                        "country": "India",
                        "state": registeredStateProvince,
                        "postal_code": registeredPostalCode.toString(),
                    },

                    "billing_address": {
                        "street_address_1": billingStreetAddress,
                        "street_address_2": billingStreetAddressLane2,
                        "city": billingCity,
                        "door_number": 'door1',
                        "country": "India",
                        "state": billingStateProvince,
                        "postal_code": billingPostalCode.toString(),
                    },
                    "shipping_address": {
                        "street_address_1": shippingStreetAddress,
                        "street_address_2": shippingStreetAddressLane2,
                        "city": shippingCity,
                        "door_number": 'door1',
                        "country": "India",
                        "state": shippingStateProvince,
                        "postal_code": shippingPostalCode.toString(),
                    },
                    "contract_number": contractNumber,
                    "contract_start_date": contractStartDate,
                    "contract_end_date": contractEndDate,
                    "notification_before": expireNotification,
                    "grace_period": gracePeriod,
                    // ===============
                    "verification_from_portal": false, //check again
                    // ============
                    // "hoto_status": hotoStatus,
                    "facility_id": selectedDraftContract.facility_id, // check again
                    "space_name": spaceName,

                    "terms_and_conditions": termsAndConditions,

                    "license_fee": licenseFee,

                    "contacts": listOfContacts
                }
                dispatch(commercialHeadUpdateFMSContract(objContract))
                setCurrentPage(currentPage + 1)

            }
            else if (currentPage >= 2 && !selectedDraftContract && newContractId) {
                //continuing to create a new contract

                let objContract = {
                    "contract_id": newContractId,
                    "contract_name": contractName.trim(),
                    "contract_status": contractStatus,
                    "billing_entity": billingEntity,
                    "primary_contact_name": contactName,
                    "primary_contact_phone_number": phoneNumber,
                    "primary_contact_email": email,
                    "company_name": companyName,
                    "pan_number": panName,
                    "gst_number": gstNumber,
                    "fms_rates": licenseTableBodyRows,
                    "cin": cinNumber,
                    "registered_address": {
                        "street_address_1": registeredStreetAddress,
                        "street_address_2": registeredStreetAddressLane2,
                        "city": registeredCity,
                        "door_number": 'door1',
                        "country": "India",
                        "state": registeredStateProvince,
                        "postal_code": registeredPostalCode.toString(),
                    },

                    "billing_address": {
                        "street_address_1": billingStreetAddress,
                        "street_address_2": billingStreetAddressLane2,
                        "city": billingCity,
                        "door_number": 'door1',
                        "country": "India",
                        "state": billingStateProvince,
                        "postal_code": billingPostalCode.toString(),
                    },
                    "shipping_address": {
                        "street_address_1": shippingStreetAddress,
                        "street_address_2": shippingStreetAddressLane2,
                        "city": shippingCity,
                        "door_number": 'door1',
                        "country": "India",
                        "state": shippingStateProvince,
                        "postal_code": shippingPostalCode.toString(),
                    },
                    "contract_number": contractNumber,
                    "contract_start_date": contractStartDate,
                    "contract_end_date": contractEndDate,
                    "notification_before": expireNotification,
                    "grace_period": gracePeriod,
                    // ===============
                    "verification_from_portal": false, //check again
                    // ============

                    "facility_id": localStorage.getItem("selected_facility_id"), // check again
                    "space_name": spaceName,

                    "terms_and_conditions": termsAndConditions,
                    "license_fee": licenseFee,
                    "contacts": listOfContacts
                }
                if (currentPage === 4) {
                    setcontractIdforReference(newContractId)
                    setSaveasDraftClicked(true)
                }
                dispatch(commercialHeadUpdateFMSContract(objContract))
                if (currentPage !== 4) {
                    setCurrentPage(currentPage + 1)
                }


            }
            else { // for creating a new contract for the first save and continuw
                let objContract = {
                    "contract_name": contractName.trim(),
                    "contract_status": contractStatus,
                    "primary_contact_name": contactName,
                    "primary_contact_phone_number": phoneNumber,
                    "primary_contact_email": email,
                    "company_name": companyName,
                    "pan_number": panName,
                    "gst_number": gstNumber,
                    "cin": cinNumber,
                    "billing_entity": billingEntity,
                    "fms_rates": licenseTableBodyRows,
                    "registered_address": {
                        "street_address_1": registeredStreetAddress,
                        "street_address_2": registeredStreetAddressLane2,
                        "city": registeredCity,
                        "door_number": 'door1',
                        "country": "India",
                        "state": registeredStateProvince,
                        "postal_code": registeredPostalCode.toString(),
                    },
                    "billing_address": {
                        "street_address_1": billingStreetAddress,
                        "street_address_2": billingStreetAddressLane2,
                        "city": billingCity,
                        "door_number": 'door1',
                        "country": "India",
                        "state": billingStateProvince,
                        "postal_code": billingPostalCode.toString(),
                    },
                    "shipping_address": {
                        "street_address_1": shippingStreetAddress,
                        "street_address_2": shippingStreetAddressLane2,
                        "city": shippingCity,
                        "door_number": 'door1',
                        "country": "India",
                        "state": shippingStateProvince,
                        "postal_code": shippingPostalCode.toString(),
                    },
                    "contract_number": contractNumber,
                    "contract_start_date": contractStartDate,
                    "contract_end_date": contractEndDate,
                    "notification_before": expireNotification,
                    "grace_period": gracePeriod,
                    // ===============
                    "verification_from_portal": false, //check again
                    // ====================

                    "facility_id": localStorage.getItem("selected_facility_id"), // check again
                    "space_name": spaceName,

                    "terms_and_conditions": termsAndConditions,
                    "license_fee": licenseFee,
                    "contacts": listOfContacts
                }
                dispatch(commercialHeadAddNewFMSContract(objContract))
                setCurrentPage(currentPage + 1)

            }
        }
    }

    const finalSave = () => {
        extractContractNameNumber();

        const isDuplicateName = contractNames.some((contract_name) => contract_name.toLowerCase() === contractName.trim().toLowerCase());
        const isReplicaValid = contractName.trim().toLowerCase() === selectedContractName.toLowerCase();
        setDuplicateContractNameError(isDuplicateName && !isReplicaValid);
        setContractName(contractName.trim())
        if (!(isDuplicateName && !isReplicaValid)) {
            if (selectedDraftContract) { // for editing a draft contract
                let objContract = {
                    "contract_id": selectedDraftContract.contract_id,
                    "contract_name": contractName.trim(),
                    "contract_status": contractStatus,
                    "primary_contact_name": contactName,
                    "primary_contact_phone_number": phoneNumber,
                    "primary_contact_email": email,
                    "billing_entity": billingEntity,
                    "company_name": companyName,
                    "pan_number": panName,
                    "gst_number": gstNumber,
                    "cin": cinNumber,
                    "fms_rates": licenseTableBodyRows,
                    "registered_address": {
                        "street_address_1": registeredStreetAddress,
                        "street_address_2": registeredStreetAddressLane2,
                        "city": registeredCity,
                        "state": registeredStateProvince,
                        "postal_code": registeredPostalCode.toString(),
                    },

                    "billing_address": {
                        "street_address_1": billingStreetAddress,
                        "street_address_2": billingStreetAddressLane2,
                        "city": billingCity,
                        "state": billingStateProvince,
                        "postal_code": billingPostalCode.toString(),
                    },
                    "shipping_address": {
                        "street_address_1": shippingStreetAddress,
                        "street_address_2": shippingStreetAddressLane2,
                        "city": shippingCity,
                        "state": shippingStateProvince,
                        "postal_code": shippingPostalCode.toString(),
                    },
                    "contract_number": contractNumber,
                    "contract_start_date": contractStartDate,
                    "contract_end_date": contractEndDate,
                    "notification_before": expireNotification,
                    "grace_period": gracePeriod,
                    // ===============
                    "verification_from_portal": false, //check again
                    // ============
                    // "hoto_status": hotoStatus,
                    "facility_id": selectedDraftContract.facility_id, // check again
                    "space_name": spaceName,

                    "terms_and_conditions": termsAndConditions,

                    "license_fee": licenseFee,

                    "contacts": listOfContacts
                }
                dispatch(commercialHeadUpdateFMSContract(objContract))
                setCurrentPage(currentPage + 1)

            }
            else if (currentPage >= 2 && !selectedDraftContract && newContractId) {
                //continuing to create a new contract

                let objContract = {
                    "contract_id": newContractId,
                    "contract_name": contractName.trim(),
                    "contract_status": contractStatus,
                    "billing_entity": billingEntity,
                    "primary_contact_name": contactName,
                    "primary_contact_phone_number": phoneNumber,
                    "primary_contact_email": email,
                    "company_name": companyName,
                    "pan_number": panName,
                    "gst_number": gstNumber,
                    "fms_rates": licenseTableBodyRows,
                    "cin": cinNumber,
                    "registered_address": {
                        "street_address_1": registeredStreetAddress,
                        "street_address_2": registeredStreetAddressLane2,
                        "city": registeredCity,
                        "state": registeredStateProvince,
                        "postal_code": registeredPostalCode.toString(),
                    },

                    "billing_address": {
                        "street_address_1": billingStreetAddress,
                        "street_address_2": billingStreetAddressLane2,
                        "city": billingCity,
                        "state": billingStateProvince,
                        "postal_code": billingPostalCode.toString(),
                    },
                    "shipping_address": {
                        "street_address_1": shippingStreetAddress,
                        "street_address_2": shippingStreetAddressLane2,
                        "city": shippingCity,
                        "state": shippingStateProvince,
                        "postal_code": shippingPostalCode.toString(),
                    },
                    "contract_number": contractNumber,
                    "contract_start_date": contractStartDate,
                    "contract_end_date": contractEndDate,
                    "notification_before": expireNotification,
                    "grace_period": gracePeriod,
                    // ===============
                    "verification_from_portal": false, //check again
                    // ============

                    "facility_id": localStorage.getItem("selected_facility_id"), // check again
                    "space_name": spaceName,

                    "terms_and_conditions": termsAndConditions,
                    "license_fee": licenseFee,
                    "contacts": listOfContacts
                }
                if (currentPage === 4) {
                    setcontractIdforReference(newContractId)
                    setSaveasDraftClicked(true)
                }
                dispatch(commercialHeadUpdateFMSContract(objContract))
                if (currentPage !== 4) {
                    setCurrentPage(currentPage + 1)
                }


            }
            else { // for creating a new contract for the first save and continuw
                let objContract = {
                    "contract_name": contractName.trim(),
                    "contract_status": contractStatus,
                    "primary_contact_name": contactName,
                    "primary_contact_phone_number": phoneNumber,
                    "primary_contact_email": email,
                    "company_name": companyName,
                    "pan_number": panName,
                    "gst_number": gstNumber,
                    "cin": cinNumber,
                    "billing_entity": billingEntity,
                    "fms_rates": licenseTableBodyRows,
                    "registered_address": {
                        "street_address_1": registeredStreetAddress,
                        "street_address_2": registeredStreetAddressLane2,
                        "city": registeredCity,
                        "state": registeredStateProvince,
                        "postal_code": registeredPostalCode.toString(),
                    },
                    "billing_address": {
                        "street_address_1": billingStreetAddress,
                        "street_address_2": billingStreetAddressLane2,
                        "city": billingCity,
                        "state": billingStateProvince,
                        "postal_code": billingPostalCode.toString(),
                    },
                    "shipping_address": {
                        "street_address_1": shippingStreetAddress,
                        "street_address_2": shippingStreetAddressLane2,
                        "city": shippingCity,
                        "state": shippingStateProvince,
                        "postal_code": shippingPostalCode.toString(),
                    },
                    "contract_number": contractNumber,
                    "contract_start_date": contractStartDate,
                    "contract_end_date": contractEndDate,
                    "notification_before": expireNotification,
                    "grace_period": gracePeriod,
                    // ===============
                    "verification_from_portal": false, //check again
                    // ====================

                    "facility_id": localStorage.getItem("selected_facility_id"), // check again
                    "space_name": spaceName,

                    "terms_and_conditions": termsAndConditions,
                    "license_fee": licenseFee,
                    "contacts": listOfContacts
                }
                dispatch(commercialHeadAddNewFMSContract(objContract))
                setCurrentPage(currentPage + 1)

            }
        }
        dispatch({
            type: PUT_CH_ADD_NEW_FMSCONTRACT_SUCCESS,
            payload: null,
        })

    }

    useEffect(() => {
        if (error) {

            if (currentPage === 4) {
                setCurrentPage(4)
            }
            else {
                setCurrentPage(currentPage - 1);
            }
        }
    }, [error])

    const [currentPage, setCurrentPage] = useState(1);

    const [listOfContacts, setListOfContacts] = useState([{
        name: "",
        phone_number: "",
        email: "",
        designation: "",

    }])

    const [listOfContactsValidation, setListOfContactsValidation] = useState([{
        isContactNameValid: true,
        isDesignationValid: true,
        isValidPhone: true,
        isValidEmail: true
    }])

    const handleAddAnotherContactValidation = () => {
        setListOfContactsValidation([...listOfContactsValidation, {
            isContactNameValid: true,
            isDesignationValid: true,
            isValidPhone: true,
            isValidEmail: true,
        }])

    }


    const handleAddAnotherContact = () => {
        setListOfContacts([...listOfContacts, {
            name: "",
            phone_number: "",
            email: "",
            designation: "",
        }])

    }



    const [showDeleteContractContact, setShowDeleteContractContact] = useState(false);

    const deleteSpecificContact = (id, contact) => {

        if (editCompleteContractClicked) {
            if (contact.contact_id) {
                setShowDeleteContractContact(true)
                setAlertShow(true)
                setAlertType('question')
                setAlertValue('Are you sure you want to delete this contact?')
                setAlertButtons([
                    {
                        name: 'Close', variant: 'outline-secondary', action: () => {
                            setAlertShow(false)
                            setShowDeleteContractContact(false)
                        }
                    },
                    {
                        name: 'Proceed', action: () => {
                            setAlertShow(false)
                            handleConfirmDeleteContractContact(id, contact)

                        }
                    },

                ])

            } else {
                const newArray = listOfContacts.filter((_, index) => index !== id);
                const newVaildArray = listOfContactsValidation.filter((_, index) => index !== id);
                setListOfContacts([...newArray]);
                setListOfContactsValidation([...newVaildArray])
            }
        }
        else {
            const newArray = listOfContacts.filter((_, index) => index !== id);
            const newVaildArray = listOfContactsValidation.filter((_, index) => index !== id);
            setListOfContacts([...newArray]);
            setListOfContactsValidation([...newVaildArray])
        }


    }

    const handleConfirmDeleteContractContact = (id, contact) => {
        setShowDeleteContractContact(false);
        axios.delete(base_url + `customers/contracts/contractContactRef`,
            {
                params: {
                    contact_id: contact.contact_id,
                    contract_id: selectedDraftContract.contract_id
                }
            }
        )
            .then((response) => {
                const newArray = listOfContacts.filter((_, index) => index !== id);
                const newVaildArray = listOfContactsValidation.filter((_, index) => index !== id);
                setListOfContacts([...newArray]);
                setListOfContactsValidation([...newVaildArray])
            })
            .catch((error) => {
                setErrorValue(error?.response?.data.message);
                setAlertShow(true)
                setAlertType('error')
                setAlertMessage('Error')
                setAlertValue(error?.response?.data.message)
                setAlertButtons([{
                    name: 'Close', action: () => {
                        setAlertShow(false)
                    }
                }])
                setIsLoading(false)
            })

    }

    const extractContractNameNumber = () => {
        // const onlyContractNumbersList = allContracts && allContracts?.map((jsonObj) => jsonObj.contract_number);
        // const newObj = [...onlyContractNumbersList]

        const onlyContractNamesList = allContracts && allContracts?.map((jsonObj) => jsonObj.contract_name);
        const newObj2 = [...onlyContractNamesList]
        // setContractNumbers([...newObj])
        setContractNames([...newObj2])
    }


    const changePageNext = () => {
        extractContractNameNumber();

        if (currentPage <= steps.length) {
            setCurrentPage(currentPage + 1)
        }
        else {
            setCurrentPage(1)
            setViewClicked(false)
            // window.location.reload();
            backfunction()
            // handleApplyFilter()
            backPagination()
            dispatch({
                type: PUT_CH_ADD_NEW_FMSCONTRACT_SUCCESS,
                payload: null,
            })
            searchFunc(searchText)
        }
    }

    const backfunction = () => {
        setEditCompleteContractClicked(false)
        setSelectedDraftContract('')
        // =======================
        setContractNumber('');
        setContractName('');
        setDuplicateContractNameError(false)
        setDuplicateContractNumberError(false)
        setIsValidEmail(true)
        setContractStatus('draft');
        setContactName('');
        setPhoneNumber('');
        setBillingEntity('');
        setEmail('');
        setCinNumber('');
        setGstNumber('');
        setCompanyName('');
        setPanName('');
        setRegisteredStreetAddress('');
        setRegisteredStreetAddressLane2('');
        setRegisteredCity('');
        setRegisteredStateProvince('');
        setRegisteredPostalCode('');
        setBillingStreetAddress('');
        setBillingStreetAddressLane2('');
        setBillingCity('');
        setBillingStateProvince('');
        setBillingPostalCode('');
        setShippingStreetAddress('');
        setShippingStreetAddressLane2('');
        setShippingCity('');
        setShippingStateProvince('');
        setShippingPostalCode('');
        setListOfContacts([
            {
                name: "",
                phone_number: "",
                email: "",
                designation: "",
            }
        ])
        setListOfContactsValidation([{
            isContactNameValid: true,
            isDesignationValid: true,
            isValidPhone: true,
            isValidEmail: true
        }])
        setContractValue('')
        setContractStartDate('')
        setContractEndDate('')
        setExpireNotification('1 month')
        setGracePeriod(0)
        setCostperUnit('')
        setSpaceName('')
        setTermsAndConditions('')
        setArea(0)
        setElectricityLoad(0)
        setTruckBays(0)
        setTwoWheelerParkingSlots(0)
        setFourWheelerParkingSlots(0)
        setLicenseFee(0)
        setEscalationRate('')
        setEscalationPeriod(0)
        setSecurityDeposit(0)
        setDgRate(0)
        setSelectedContractName('')
        setSelectedContractNumber('')
        setHotoStatus('pending')
        setLicenseFee(0)
        setLicenseTableBodyRows([{
            serial_number: 1,
            area_in_sqft: "",
            cost_per_unit: "",
            rate_start_date: "",
            rate_end_date: "",
            license_fee: ""
        }])
    }
    const closeClicked = () => {
        setCurrentPage(1)
        setViewClicked(false)
        clearValidationErrors()
        searchFunc(searchText)
        // handleApplyFilter()
        backPagination()
        backfunction()
        dispatch({
            type: PUT_CH_ADD_NEW_FMSCONTRACT_SUCCESS,
            payload: null,
        })
    }



    const changePagePrev = () => {

        if (currentPage === 2) {
            setSelectedDraftContract(null)
            setViewClicked(false)
            clearValidationErrors()
            // window.location.reload();
            backfunction()
            searchFunc(searchText)
        }
        setCurrentPage(currentPage - 1)
        if (!selectedDraftContract) {
            dispatch(commercialHeadGetDocuments({ contract_name: contractName }))
        }
        else {
            dispatch(commercialHeadGetDocuments({ contract_name: selectedDraftContract.contract_name }))
        }
    }

    const typesOfContracts = [
        {
            name: "All Contracts",
            id: "all"
        },
        {
            name: "Draft Contracts",
            id: "draft"
        },

    ]




    const onchangeContractType = (value) => {
        setContractType(value)
        if (value === "all") {
            const copyContracts = allContracts
            setFilteredContracts([...copyContracts])
            setContractsList([...copyContracts])

        }
        else {
            const copyContracts = alldraftContracts
            setFilteredContracts([...copyContracts])
            setContractsList([...copyContracts])

        }
    }

    const [selectedDraftContract, setSelectedDraftContract] = useState()



    // ================= Create new Contract Page 1 ================================
    const [contractNumber, setContractNumber] = useState('');
    const [contractName, setContractName] = useState('');
    const [contractStatus, setContractStatus] = useState('draft');
    const [contactName, setContactName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [email, setEmail] = useState("");
    const [gstNumber, setGstNumber] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [panName, setPanName] = useState('');
    const [registeredStreetAddress, setRegisteredStreetAddress] = useState('');
    const [registeredStreetAddressLane2, setRegisteredStreetAddressLane2] = useState('');
    const [registeredCity, setRegisteredCity] = useState('');
    const [registeredStateProvince, setRegisteredStateProvince] = useState('');
    const [registeredPostalCode, setRegisteredPostalCode] = useState('');

    // =================Create New Contract Page 2 =========================

    const [billingStreetAddress, setBillingStreetAddress] = useState('');
    const [billingStreetAddressLane2, setBillingStreetAddressLane2] = useState('');
    const [billingCity, setBillingCity] = useState('');
    const [billingStateProvince, setBillingStateProvince] = useState('');
    const [billingPostalCode, setBillingPostalCode] = useState('');

    const [shippingStreetAddress, setShippingStreetAddress] = useState('');
    const [shippingStreetAddressLane2, setShippingStreetAddressLane2] = useState('');
    const [shippingCity, setShippingCity] = useState('');
    const [shippingStateProvince, setShippingStateProvince] = useState('');
    const [shippingPostalCode, setShippingPostalCode] = useState('');

    // ==================== Create New Contract Page 3 ==============

    const [contractValue, setContractValue] = useState('');


    const [contractBillingType, setContractBillingType] = useState('half yearly');
    const [expireNotification, setExpireNotification] = useState('1 month');
    const [costperUnit, setCostperUnit] = useState('');

    // =================== Create New Contract 4 =================

    const [fileData, setFileData] = useState(null);
    const [termsAndConditions, setTermsAndConditions] = useState(null);


    const [spaceName, setSpaceName] = useState('');
    const [area, setArea] = useState(0);
    const [electricityLoad, setElectricityLoad] = useState(0);
    const [truckBays, setTruckBays] = useState(0);
    const [twoWheelerParkingSlots, setTwoWheelerParkingSlots] = useState(0);
    const [fourWheelerParkingSlots, setFourWheelerParkingSlots] = useState(0);
    const [licenseFee, setLicenseFee] = useState(0);
    const [escalationRate, setEscalationRate] = useState('');
    const [escalationPeriod, setEscalationPeriod] = useState(0);
    const [securityDeposit, setSecurityDeposit] = useState(0);
    const [dgRate, setDgRate] = useState(0);
    const [hotoStatus, setHotoStatus] = useState('pending')
    const [initialDgReading, setInitialDgReading] = useState(0);


    // ============================ end of input fields ==========================================


    const handleCheckboxChange = (index, field) => {
        const updatedContacts = [...listOfContacts];
        updatedContacts[index][field] = !updatedContacts[index][field] ? 1 : 0;
        setListOfContacts(updatedContacts);
    };

    const [isValidEmail, setIsValidEmail] = useState(true);

    const handleEmailChange = (e) => {
        const input = e.target.value;

        const { processedInput, isValid } = processAndValidateEmail(input, email);

        setEmail(processedInput);
        setIsValidEmail(isValid);
    };

    const [isValidPhone, setIsValidPhone] = useState(true);
    const [isContractNameValid, setIsContractNameValid] = useState([]);

    const [isContactNameValid, setIsContactNameValid] = useState(true)
    const [isPincodeValid, setIsPincodeValid] = useState(true)
    const [isShippingPincodeValid, setIsShippingPincodeValid] = useState(true)
    const [validContractNumber, setValidContractNumber] = useState(true)

    const [isValidGstNumber, setIsValidGstNumber] = useState(true);

    const [isSpaceNameValid, setIsSpaceNameValid] = useState(true);

    const [isCinValid, setIsCinValid] = useState(true);

    const handleCinNumberChange = (e) => {
        const input = e.target.value;
        const cinRegex = /^[A-Z]{1}[0-9]{5}[A-Z]{2}[0-9]{4}[A-Z]{3}[0-9]{6}$/;

        if (cinRegex.test(input) || input === '') {
            setCinNumber(input);
            setIsCinValid(true);
        }
        else {
            setCinNumber(input);
            setIsCinValid(false);
        }
    }

    const handleGstNumberChange = (e) => {
        const input = e.target.value;
        const { isValid, uppercasedInput } = validateGstNumber(input);
        setGstNumber(uppercasedInput);
        setIsValidGstNumber(isValid);
    };

    const [editCompleteContractClicked, setEditCompleteContractClicked] = useState(false);
    const [viewCompleteContractClicked, setViewCompleteContractClicked] = useState(false)
    const [selectedIdForDocuments, setSelectedIdForDocuments] = useState();

    const editDraftContract = (contract) => {
    }

    const viewSelectedContract = (contract) => {
        setViewClicked(true)
        setIsLoading(true)
        setSelectedIdForDocuments(contract["contract_id"])
        setViewCompleteContractClicked(true)
        axios.get(base_url + "customers/fmsContracts?filter_condition=%7B%22contract_id%22%3A%20%22" + contract["contract_id"] + "%22%7D")
            .then((response) => {
                setIsLoading(false)
                let contractDetailsInitial = response.data.data
                const contractDetails = contractDetailsInitial
                dispatch(commercialHeadGetDocuments({ contract_name: contractDetails.contract_name }))

                setSelectedDraftContract(contractDetails)
                // =======================
                setContractNumber(contractDetails?.contract_number);
                setSelectedContractNumber(contractDetails?.contract_number)
                setContractName(contractDetails?.contract_name);
                setSelectedContractName(contractDetails?.contract_name)
                setContractStatus(contractDetails?.contract_status);
                setContactName(contractDetails?.primary_contact_name);
                setPhoneNumber(contractDetails?.primary_contact_phone_number);
                setEmail(contractDetails?.primary_contact_email);
                setCinNumber(contractDetails?.cin);
                setGstNumber(contractDetails?.gst_number);
                setCompanyName(contractDetails?.company_name);
                setPanName(contractDetails?.pan_number);
                setBillingEntity(contractDetails?.billing_entity);

                let registeredAddressString = contractDetails?.registered_address;
                // registeredAddressString = registeredAddressString.replace(/'/g, '"');                    
                const parsedRegisteredAddress = registeredAddressString;
                setRegisteredStreetAddress(parsedRegisteredAddress?.street_address_1);
                setRegisteredStreetAddressLane2(parsedRegisteredAddress?.street_address_2);
                setRegisteredCity(parsedRegisteredAddress?.city);
                setRegisteredStateProvince(parsedRegisteredAddress?.state);
                setRegisteredPostalCode(parsedRegisteredAddress?.postal_code);

                // ========================= page 3 ===================
                let billingAddressString = contractDetails?.billing_address;
                // billingAddressString = billingAddressString.replace(/'/g, '"');                  
                const parsedBillingAddress = billingAddressString;
                setBillingStreetAddress(parsedBillingAddress?.street_address_1);
                setBillingStreetAddressLane2(parsedBillingAddress?.street_address_2);
                setBillingCity(parsedBillingAddress?.city);
                setBillingStateProvince(parsedBillingAddress?.state);
                setBillingPostalCode(parsedBillingAddress?.postal_code);
                let shippingAddressString = contractDetails?.shipping_address;
                const parseShippingaddress = shippingAddressString;
                setShippingStreetAddress(parseShippingaddress?.street_address_1);
                setShippingStreetAddressLane2(parseShippingaddress?.street_address_2);
                setShippingCity(parseShippingaddress?.city);
                setShippingStateProvince(parseShippingaddress?.state);
                setShippingPostalCode(parseShippingaddress?.postal_code);
                if (contractDetails?.contacts === "None" || !contractDetails?.contacts) {
                    setListOfContacts([{

                        contactName: "",
                        phoneNumber: "",
                        email: "",
                        designation: "",
                    }]);
                }
                else {
                    let contactsString = contractDetails?.contacts;
                    const parsedContacts = contactsString;
                    setListOfContacts(parsedContacts)

                    const defaultContactsValidation = Array.from({ length: parsedContacts.length }, () => ({
                        isContactNameValid: true,
                        isDesignationValid: true,
                        isValidPhone: true,
                        isValidEmail: true,
                    }));
                    setListOfContactsValidation([...defaultContactsValidation])
                }


                // ====================== page 4 =====================

                // setContractValue(contractDetails?.contract_value)
                setContractStartDate(contractDetails?.contract_start_date === '0000-00-00' ? '' : contractDetails?.contract_start_date)
                setContractEndDate(contractDetails?.contract_end_date === '0000-00-00' ? '' : contractDetails?.contract_end_date)
                // setContractBillingType(contractDetails?.contract_billing_type)
                setExpireNotification(contractDetails?.notification_before)
                setGracePeriod(contractDetails?.grace_period)
                // setCostperUnit(contractDetails?.cost_per_unit)


                // ======================= page 5 ================
                setSpaceName(contractDetails?.space_name)
                setTermsAndConditions(contractDetails?.terms_and_conditions)
                setLicenseFee(contractDetails?.license_fee)
                let listSlfValue = contractDetails?.fms_rates;
                setLicenseTableBodyRows([...listSlfValue])
                setSlfTableError(licenseFeeDateValidationByStartDateEndDate(listSlfValue, contractDetails?.contract_start_date, contractDetails?.contract_end_date))

                // ============================functionality below =================
                setCurrentPage(2)
            })
            .catch((error) => {
                setErrorValue(error?.response?.data.message);
                setAlertShow(true)
                setAlertType('error')
                setAlertMessage('Error')
                setAlertValue(error?.response?.data.message)
                setAlertButtons([{
                    name: 'Close', action: () => {
                        setAlertShow(false)
                    }
                }])
                setIsLoading(false)
            });

    }


    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [draftIdDelete, setDraftIdDelete] = useState(null);
    const [draftContractNumberDelete, setDraftContractNumberDelete] = useState(null)
    const handleDeleteClick = (each) => {
        setDraftContractNumberDelete(each.contract_name)
        setDraftIdDelete(each.draft_id);
        setShowDeleteModal(true);
    };
    const handleProceedClick = () => {
        axios
            .delete(base_url + "customers/draftContracts",
                {
                    params: {
                        "draft_id": draftIdDelete,
                    },
                })
            .then((response) => {
                if (response?.data?.data[0] === 'error') {
                    setErrorValue(response?.data?.data[1].message)
                    setAlertShow(true)
                    setAlertType('error')
                    setAlertMessage('Error')
                    setAlertValue(response?.data?.data[1].message)
                    setAlertButtons([
                        {
                            name: 'Close', action: () => {
                                setAlertShow(false)
                            }
                        },
                    ])
                    setIsLoading(false)
                }
                else {
                    dispatch(commercialHeadGetFMSDraftContracts({ facility_id: localStorage.getItem("selected_facility_id"), search_text: searchText, items_per_page: RECORDS_PER_PAGE, page_number: currentPaginationPageDc }));
                }
            })
            .catch((error) => {
                setErrorValue(error?.response?.data.message);
                setAlertShow(true)
                setAlertType('error')
                setAlertMessage('Error')
                setAlertValue(error?.response?.data.message)
                setAlertButtons([{
                    name: 'Close', action: () => {
                        setAlertShow(false)
                    }
                }])
                setIsLoading(false)
            });
        setShowDeleteModal(false);
    };
    const handleCancelClick = () => {
        setShowDeleteModal(false);
    };

    const sortCompanyName = () => {
        let sortedList = filteredContracts.sort((a, b) => {
            const nameA = a.company_name.toLowerCase();
            const nameB = b.company_name.toLowerCase();
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        });
        if (companyNameFilter) {
            setCompanyNameFilter(!companyNameFilter)
            sortedList.reverse()
        } else {
            setCompanyNameFilter(!companyNameFilter)
        }
        setFilteredContracts([...sortedList])
    }
    const sortContractName = () => {
        let sortedList = filteredContracts.sort((a, b) => {
            const nameA = a.contract_name.toLowerCase();
            const nameB = b.contract_name.toLowerCase();
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        });
        if (companyNameFilter) {
            setCompanyNameFilter(!companyNameFilter)
            sortedList.reverse()
        } else {
            setCompanyNameFilter(!companyNameFilter)
        }
        setFilteredContracts([...sortedList])
    }

    const sortSpaceName = () => {
        let sortedList = filteredContracts.sort((a, b) => {
            const nameA = a.space_name.toLowerCase();
            const nameB = b.space_name.toLowerCase();
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        });
        if (companyNameFilter) {
            setCompanyNameFilter(!companyNameFilter)
            sortedList.reverse()
        } else {
            setCompanyNameFilter(!companyNameFilter)
        }
        setFilteredContracts([...sortedList])
    }
    const sortContractNumber = () => {
        let sortedList = filteredContracts.sort((a, b) => {
            const nameA = a.contract_number.toLowerCase();
            const nameB = b.contract_number.toLowerCase();
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        });
        if (companyNameFilter) {
            setCompanyNameFilter(!companyNameFilter)
            sortedList.reverse()
        } else {
            setCompanyNameFilter(!companyNameFilter)
        }
        setFilteredContracts([...sortedList])
    }

    const sortContractType = () => {
        let sortedList = filteredContracts.sort((a, b) => {
            const nameA = a.contract_billing_type.toLowerCase();
            const nameB = b.contract_billing_type.toLowerCase();
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        });
        if (companyNameFilter) {
            setCompanyNameFilter(!companyNameFilter)
            sortedList.reverse()
        } else {
            setCompanyNameFilter(!companyNameFilter)
        }
        setFilteredContracts([...sortedList])
    }
    const sortEmail = () => {
        let sortedList = filteredContracts.sort((a, b) => {
            const nameA = a.primary_contact_email.toLowerCase();
            const nameB = b.primary_contact_email.toLowerCase();
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        });
        if (companyNameFilter) {
            setCompanyNameFilter(!companyNameFilter)
            sortedList.reverse()
        } else {
            setCompanyNameFilter(!companyNameFilter)
        }
        setFilteredContracts([...sortedList])
    }

    const sortStatus = () => {
        let sortedList = filteredContracts.sort((a, b) => {
            const nameA = a.contract_status;
            const nameB = b.contract_status;
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        });
        if (companyNameFilter) {
            setCompanyNameFilter(!companyNameFilter)
            sortedList.reverse()
        } else {
            setCompanyNameFilter(!companyNameFilter)
        }
        setFilteredContracts([...sortedList])
    }

    const sortUpdatedDate = () => {
        let sortedList = filteredContracts.sort((a, b) => {
            const nameA = a.updated_at.split(" ")[0];
            const nameB = b.updated_at.split(" ")[0];
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        });
        if (companyNameFilter) {
            setCompanyNameFilter(!companyNameFilter)
            sortedList.reverse()
        } else {
            setCompanyNameFilter(!companyNameFilter)
        }
        setFilteredContracts([...sortedList])

    }
    function printMousePos(event) {
        const MousePositionY = event.clientY;
        if (MousePositionY < 450) {
            setPopOverPosition('bottom')
        }
        else {
            setPopOverPosition('top')
        }
    }

    const handleGstClick = (gstId) => {
        setGstLoader(true)
        axios.get(base_url + "gstPortal/verifyGstin?gst_number=" + gstId)
            .then((response) => {
                if (response?.data?.data[0] === 'error') {
                    setErrorValue(response?.data?.data[1].message)
                    setAlertShow(true)
                    setAlertType('error')
                    setAlertMessage('Error')
                    setAlertValue(response?.data?.data[1].message)
                    setAlertButtons([
                        {
                            name: 'Close', action: () => {
                                setAlertShow(false)
                            }
                        },
                    ])
                    setIsLoading(false)
                    setGstLoader(false);
                }
                else {
                    const details = response.data.data
                    setGstLoader(false)
                    setCompanyName(details?.company_name)
                    setPanName(details?.pan_number)
                    setRegisteredStateProvince(details?.registered_address?.state)
                    setRegisteredPostalCode(details?.registered_address?.postal_code)
                    setRegisteredStreetAddress(details?.registered_address?.door_number + details?.registered_address?.street_address_1)
                    setRegisteredStreetAddressLane2(details?.registered_address?.street_address_2)
                    setRegisteredCity(details?.registered_address?.city)
                    setBillingStateProvince(details?.registered_address?.state)
                    setShippingStateProvince(details?.registered_address?.state)

                }
            })
            .catch((error) => {
                const errorDetails = JSON.parse(error.response.data.error_logs.status_desc);
                const errorMessage = errorDetails[0].ErrorMessage
                setErrorValue(errorMessage);
                setAlertShow(true);
                setAlertType('error');
                setAlertMessage('Error');
                setAlertValue(errorMessage);
                setAlertButtons([
                    {
                        name: 'Close',
                        action: () => {
                            setAlertShow(false);
                        }
                    }
                ]);
                setIsLoading(false);
                setGstLoader(false);
            });
    }

    const clearValidationErrors = () => {
        // current page 2
        setIsContractNameValid(true)
        setIsCinValid(true)
        setDuplicateContractNameError(false)
        setDuplicateContractNumberError(false)
        setIsContactNameValid(true)
        setIsValidPhone(true)
        setIsValidEmail(true)
        setIsPincodeValid(true)
        setIsShippingPincodeValid(true)
        setIsValidGstNumber(true)
        // current page 4
        setIsContractNumberValid(true)
        setIsSpaceNameValid(true)

    }

    const checkSaveandContinueValidation = () => {
        if (currentPage === 2) {
            const isValid = !isContractNameValid || duplicateContractNameError || contractName === '' || duplicateContractNumberError ||
                !isContactNameValid || !isValidEmail || !isValidGstNumber || billingEntity === ''
                || billingEntity === 'Select Billing Entity' || billingEntity === 'Select Billing Entity' || !isCinValid
                || !contractNumber || !isContractNumberValid || gstNumber === ''
            // || cinNumber === '' 
            return isValid
        }
        if (currentPage === 3) {
            const isValid = !isContractNameValid || duplicateContractNameError || contractName === '' || duplicateContractNumberError ||
                !isContactNameValid || !isValidEmail || !isValidGstNumber || billingEntity === ''
                || billingEntity === 'Select Billing Entity' || billingEntity === 'Select Billing Entity' || !isCinValid
                || !contractNumber || !isContractNumberValid || gstNumber === ''
            // || cinNumber === '' 
            const isValidContactList = listOfContactsValidation.some(e =>
                e.isContactNameValid === false ||
                e.isDesignationValid === false ||
                e.isValidPhone === false ||
                e.isValidEmail === false
            );
            return (isValid || isValidContactList)
        }
        if (currentPage === 4) {
            const isValid = !isContractNameValid || duplicateContractNameError || contractName === '' || duplicateContractNumberError ||
                !isContactNameValid || !isValidEmail || !isValidGstNumber || billingEntity === ''
                || billingEntity === 'Select Billing Entity' || billingEntity === 'Select Billing Entity' || !isCinValid || dateError
                || !contractNumber || !isContractNumberValid || gstNumber === ''
            // || cinNumber === '' 
            const isValidContactList = listOfContactsValidation.some(e =>
                e.isContactNameValid === false ||
                e.isDesignationValid === false ||
                e.isValidPhone === false ||
                e.isValidEmail === false
            );

            return (isValid || isValidContactList)
        }
    }
    const checkSaveDraftValidation = () => {
        const isValid = !isContactNameValid || duplicateContractNameError || contractName === '' || duplicateContractNumberError ||
            !isContactNameValid || !isValidEmail || !isValidGstNumber ||
            !isSpaceNameValid || !isPincodeValid || !validContractNumber || !isShippingPincodeValid
        const isValidContactList = listOfContactsValidation.some(e =>
            e.isContactNameValid === false ||
            e.isDesignationValid === false ||
            e.isValidPhone === false ||
            e.isValidEmail === false
        );




        // license fee detials validation are still yet to be implemented
        return (isValid || isValidContactList)
    }

    const contactValidationsFunc = () => {
        const isValidContactListValidations = listOfContactsValidation.some(e =>
            e.isContactNameValid === false ||
            e.isDesignationValid === false ||
            e.isValidPhone === false ||
            e.isValidEmail === false
        );
        const isValidContactList = listOfContacts.some(e =>
            !e.name ||
            // !e.phone_number ||
            !e.email
            // ||
            // !e.designation
        );
        return !isValidContactList && !isValidContactListValidations
    }

    const slfValidationsFunc = () => {
        const isLicenseFeeValid = licenseTableBodyRows.some(e =>
            // e.area_in_sqft === '' ||
            // e.cost_per_unit === '' ||
            e.rate_start_date === '' ||
            e.rate_end_date === '' ||
            e.license_fee === '' ||
            // !e.area_in_sqft ||
            // !e.cost_per_unit ||
            slfTableError?.error ||
            e.license_fee === null ||
            Number.isNaN(Number(e.license_fee))
        )
        return isLicenseFeeValid || licenseTableBodyRows.length === 0
    }
    const toTitleCase = (value) => {
        return value?.split(' ').map(word => {
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        }).join(' ');
    }

    // =================================File operations ======================
    const [uploadedFile, setUploadedFile] = useState(null);
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setUploadedFile(file)
        const reader = new FileReader();
        reader.onloadend = function () {
            dispatch(commercialHeadUploadDocument(
                {
                    files: [
                        {
                            file_content: reader.result.split(",")[1],
                            object_type: "contracts",
                            file_type: file.type.split("/")[1],
                            file_name: file.name,
                            contract_name: contractName,
                            flag: "duplicate"
                        }
                    ]
                }
            )

            )
        }
        reader.readAsDataURL(file);
    }
    const [uploadedFiles, setUploadedFiles] = useState();
    const [contractDocumentsList, setContractDocumentsList] = useState([]);

    const handleFilesSelected = (files) => {
        if (selectedDraftContract) {
            const processedFiles = [];
            files.forEach((file) => {
                const reader = new FileReader();

                reader.onloadend = function () {
                    const base64FileContent = reader.result.split(",")[1];
                    // const required_id = selectedDraftContract && selectedDraftContract.draft_id
                    const processedFile = {
                        file_content: base64FileContent,
                        object_type: "drafts",
                        file_description: file.description,
                        file_type: file.file.type.split("/")[1],
                        file_name: file.file.name,
                        // draft_id:required_id,
                        contract_name: selectedDraftContract && selectedDraftContract.contract_name,
                        file_size: file.file.size,
                        flag: file.flag,
                        user_id: localStorage.getItem("username"),
                    };
                    processedFiles.push(processedFile);
                    if (processedFiles.length === files.length) {
                        setUploadedFiles(processedFiles);
                    }
                };

                reader.readAsDataURL(file.file);
            });

        }
        else if (!selectedDraftContract && newContractId) {
            const processedFiles = [];
            files.forEach((file) => {
                const reader = new FileReader();

                reader.onloadend = function () {
                    const base64FileContent = reader.result.split(",")[1];
                    const required_id = newContractId
                    const processedFile = {
                        file_content: base64FileContent,
                        object_type: "drafts",
                        file_description: file.description,
                        file_type: file.file.type.split("/")[1],
                        file_name: file.file.name,
                        draft_id: required_id,
                        contract_name: contractName,
                        file_size: file.file.size,
                        flag: null,
                        user_id: localStorage.getItem("username"),
                    };
                    processedFiles.push(processedFile);
                    if (processedFiles.length === files.length) {
                        setUploadedFiles(processedFiles);
                    }
                };

                reader.readAsDataURL(file.file);
            });


        }
        else {
            const processedFiles = [];
            files.forEach((file) => {
                const reader = new FileReader();

                reader.onloadend = function () {
                    const base64FileContent = reader.result.split(",")[1];
                    const processedFile = {
                        file_content: base64FileContent,
                        object_type: "contracts",
                        file_description: file.description,
                        file_type: file.file.type.split("/")[1],
                        file_name: file.file.name,
                        contract_id: selectedDraftContract.contract_id,
                        file_size: file.file.size,
                        flag: null,
                        user_id: localStorage.getItem("username"),
                    };
                    processedFiles.push(processedFile);
                    if (processedFiles.length === files.length) {
                        setUploadedFiles(processedFiles);
                    }
                };

                reader.readAsDataURL(file.file);
            });
        }

    };
    const handleDocumentUpload = (index) => {
        dispatch(handleDocumentLoaderTrue())
        dispatch(commercialHeadUploadDocument(
            {
                files: [uploadedFiles[index]]
            }
        ))
    }

    const handleSelectTermsAndCondition = (files) => {
        setTermsAndConditions(null)
        let processedFiles1 = [];
        files.forEach((file) => {
            const reader1 = new FileReader();
            reader1.onloadend = function () {
                const base64FileContent = reader1.result.split(",")[1];
                const processedFile1 = {
                    file_content: base64FileContent,
                    file_name: file?.file?.name,
                    file_type: "pdf",
                    object_type: "terms_documents",
                    flag: null,
                    document_type: "tandc",
                    user_id: localStorage.getItem("username"),
                    contract_name: contractName

                };
                processedFiles1 = [...processedFiles1, processedFile1];
                if (processedFiles1.length === files.length) {
                    setFileData(processedFiles1);
                }
            };
            reader1.readAsDataURL(file.file);
        });
    }
    const handleTermsAndConditionsUpload = (index) => {
        const data = { "files": [fileData[index]] }
        dispatch(handleDocumentLoaderTrue())
        axios.post(base_url + "documents", data)
            .then((response) => {
                if (response.status === 200) {
                    setTermsAndConditions(response.data.data[0].key)
                    dispatch(handleDocumentLoaderFalse())
                }
            })
            .catch((error) => {
                console.log(error)
            })
    }

    const [showConfirmDeleteModel, setConfirmDeleteModel] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState();

    const handleCloseConfirmDeleteModal = () => {
        setConfirmDeleteModel(false);
    };

    const confirmDeleteDocument = (index) => {
        setConfirmDeleteModel(true);
        setSelectedIndex(index);
    }

    const handleDocumentDelete = () => {
        setConfirmDeleteModel(false)
        dispatch(handleDocumentLoaderTrue())
        if (documentList.length > selectedIndex) {
            axios.delete(base_url + `documents`,
                {
                    data: {
                        s3_keys: [documentList[selectedIndex]?.key],

                    }
                }
            )
                .then((response) => {
                    if (response?.data?.data[0] === 'error') {
                        setErrorValue(response?.data?.data[1].message)
                        setAlertShow(true)
                        setAlertType('error')
                        setAlertMessage('Error')
                        setAlertValue(response?.data?.data[1].message)
                        setAlertButtons([
                            {
                                name: 'Close', action: () => {
                                    setAlertShow(false)
                                }
                            },
                        ])
                        setIsLoading(false)
                    }
                    else {
                        dispatch(handleDocumentLoaderFalse())
                        let newDocumentList = [...documentList];
                        newDocumentList.splice(selectedIndex, 1);
                        setDocumentList(newDocumentList);
                    }
                })
                .catch((error) => {
                    handleDocumentLoaderFalse()
                    setErrorValue(error?.response?.data.message);
                    setAlertShow(true)
                    setAlertType('error')
                    setAlertMessage('Error')
                    setAlertValue(error?.response?.data.message)
                    setAlertButtons([{
                        name: 'Close', action: () => {
                            setAlertShow(false)
                        }
                    }])
                    setIsLoading(false)
                })
        }
        else {
            setConfirmDeleteModel(false)
        }

    }

    const handleErrorFromDocument = (value) => {
        setErrorValue(value)
    }

    const isSubmitActive = () => {

        if (
            // ================ Page 1 validations =================
            contractName && isContractNameValid && contactName
            && contractNumber && isContractNumberValid && billingEntity && billingEntity !== 'Select'
            && isContactNameValid && email && isValidEmail &&
            gstNumber && companyName && panName && registeredStreetAddress &&
            registeredStreetAddressLane2 &&
            registeredCity && registeredStateProvince && registeredPostalCode &&
            isValidGstNumber
            // && cinNumber 
            && isCinValid && contactValidationsFunc() &&
            // ================== Page 2 validations =================
            billingStreetAddress && billingStreetAddressLane2 && billingCity &&
            billingStateProvince && billingPostalCode && isPincodeValid &&
            shippingStreetAddress && shippingStreetAddressLane2 && shippingCity
            && shippingStateProvince && shippingPostalCode && isShippingPincodeValid &&
            // ===================== Page 3 validations =================
            spaceName && isSpaceNameValid && contractStartDate
            && contractStartDate !== '' &&
            contractEndDate && contractEndDate !== ''
            && expireNotification &&
            gracePeriod >= 0 && termsAndConditions && !slfValidationsFunc()

        ) {
            return true
        }
        else {
            return false
        }
    }

    const handledPaginationNextClicked = () => {
        setIsLoading(true)
        handlePaginationLoaderTrue()
        dispatch(commercialHeadGetFMSContracts({ facility_id: localStorage.getItem("selected_facility_id"), status: statusFilter, search_text: searchText, items_per_page: RECORDS_PER_PAGE, page_number: currentPaginationPageAc + 1 }))
    }

    const handledPaginationPrevClicked = () => {
        setIsLoading(true)
        dispatch(commercialHeadGetFMSContracts({ facility_id: localStorage.getItem("selected_facility_id"), status: statusFilter, search_text: searchText, items_per_page: RECORDS_PER_PAGE, page_number: currentPaginationPageAc - 1 }))


    }

    const handleStatusFilter = (e) => {
        setStatusFilter(e.target.value)
    }

    const handleApplyFilter = () => {
        setIsLoading(true)
        dispatch(commercialHeadGetFmsContractsForDropdown())
        dispatch(commercialHeadGetFMSContracts({ facility_id: localStorage.getItem("selected_facility_id"), status: statusFilter, search_text: searchText, items_per_page: RECORDS_PER_PAGE, page_number: 1 }))
    }
    const backPagination = () => {
        setIsLoading(true)
        dispatch(commercialHeadGetFmsContractsForDropdown())
        dispatch(commercialHeadGetFMSContracts({ facility_id: localStorage.getItem("selected_facility_id"), status: statusFilter, search_text: searchText, items_per_page: RECORDS_PER_PAGE, page_number: currentPaginationPageAc }))
    }

    const handleClearFilters = () => {
        setIsLoading(true)
        setStatusFilter('active')
        setSearchText('')
        dispatch(commercialHeadGetFMSContracts({ facility_id: localStorage.getItem("selected_facility_id"), status: "active", search_text: "", items_per_page: RECORDS_PER_PAGE, page_number: 1 }))
    }

    const checkmarkVisibilityCalculationPage2 = () => {
        return (contractName && isContractNameValid && contractStatus && contactName && !duplicateContractNameError && !duplicateContractNumberError
            && contractNumber && isContractNumberValid && billingEntity && billingEntity !== 'Select'
            && isContactNameValid && email && isValidEmail &&
            gstNumber && companyName && panName && registeredStreetAddress &&
            registeredStreetAddressLane2 &&
            registeredCity && registeredStateProvince && registeredPostalCode &&
            isValidGstNumber
            //  && cinNumber 
            && isCinValid && contactValidationsFunc())
    }

    const checkmarkVisibilityCalculationPage3 = () => {
        return (billingStreetAddress && billingStreetAddressLane2 && billingCity &&
            billingStateProvince && billingPostalCode && isPincodeValid && shippingStreetAddress && shippingStreetAddressLane2 && shippingCity
            && shippingStateProvince && shippingPostalCode && isShippingPincodeValid)
    }

    const checkmarkVisibilityCalculationPage4 = () => {
        return (spaceName && isSpaceNameValid && contractStartDate && contractStartDate !== '' &&
            contractEndDate && contractEndDate !== ''
            && expireNotification &&
            gracePeriod >= 0 && termsAndConditions && !slfValidationsFunc())

    }

    const missingFieldsCalculatePage2 = () => {
        return `${(!contractName || !isContractNameValid) ? "Contract Name, " : " "}
        ${(!contractStatus) ? "Contract Status, " : " "} ${!contactName ? "Primary Contact Name," : " "}
        ${duplicateContractNameError ? "Contract Name a, " : " "}${duplicateContractNumberError ? "Contract Number, " : " "}
        ${(!contractNumber || !isContractNumberValid) ? "Contract Number, " : " "}
        ${(!billingEntity || billingEntity === 'Select') ? "Billing Entity, " : " "}
        ${(!isContactNameValid) ? "Contact Name, " : " "}
        ${(!email || !isValidEmail) ? "Primary Email, " : " "}
        ${(!gstNumber || !isValidGstNumber) ? "GST Number, " : " "}
        ${(!companyName) ? "Company Name, " : " "}
        ${(!panName) ? "PAN Number, " : " "}
        ${(!registeredStreetAddress) ? "Registered Street Address, " : " "}
        ${(!registeredStreetAddressLane2) ? "Registered Street Address Lane 2, " : " "}
        ${(!registeredCity) ? "Registered City, " : " "}
        ${(!registeredStateProvince) ? "Registered State/Province, " : " "}
        ${(!registeredPostalCode) ? "Registered Postal Code, " : " "}
        ${(!isCinValid) ? "CIN, " : " "}
        ${(!contactValidationsFunc()) ? "Secondary Contact Details List" : " "}`
    }

    const missingFieldsCalculatePage3 = () => {
        return `${!billingStreetAddress ? "Billing Street Address, " : " "} 
        ${!billingStreetAddressLane2 ? "Billing Street Address Lane 2, " : " "}
        ${!billingCity ? "Billing City, " : " "}
        ${!billingStateProvince ? "Billing State/Province, " : " "}
        ${!billingPostalCode ? "Billing Postal Code, " : " "}
        ${!isPincodeValid ? "Billing Postal Code, " : " "}
        ${!shippingStreetAddress ? "Shipping Street Address, " : " "}
        ${!shippingStreetAddressLane2 ? "Shipping Street Address Lane 2, " : " "}
        ${!shippingCity ? "Shipping City, " : " "}
        ${!shippingStateProvince ? "Shipping State/Province, " : " "} 
        ${!shippingPostalCode ? "Shipping Postal Code, " : " "}
        ${!isShippingPincodeValid ? "Shipping Postal Code, " : " "}`
    }
    const missingFieldsCalculatePage4 = () => {
        return `${!spaceName ? "Space Name, " : " "}
        ${!isSpaceNameValid ? "Space Name, " : " "}
        ${!contractStartDate ? "Contract Start Date, " : " "}
        ${!(contractStartDate !== '') ? "Contract Start Date, " : " "}
        ${!contractEndDate && !(contractEndDate !== '') ? "Contract End Date, " : " "}
        ${!expireNotification ? "Notification Before, " : " "}
        ${!(gracePeriod >= 0) ? "Grace Period, " : " "} 
        ${slfValidationsFunc() ? "FMS Rates Table, " : " "}
        ${!termsAndConditions ? "Terms and Conditions " : " "}
        `

    }


    return (
        <>
            <>
                <NavBarTop />
                <LeftNavBar />
            </>
            <Modal keyboard={false} backdrop="static" show={showDraftModal} onHide={handleCloseDraftModal} centered className="popper-modal">
                <Modal.Body className="text-center">
                    <img src="./images/icons/popper.svg" alt="Party Popper" />
                    <h5>Success!</h5>
                    {
                        selectedDraftContract && selectedDraftContract ?
                            <p className="mb-3">Draft contract <b>{selectedDraftContract?.contract_name}</b> has been successfully updated.</p>
                            :
                            <p className="mb-3">Draft contract <b>{contractName}</b> has been successfully created.</p>
                    }
                </Modal.Body>
                <Modal.Footer className="footer">
                    <Button variant="secondary" className="secondary" onClick={handleCloseModal} >
                        Close
                    </Button>
                    <Button variant="secondary" className="secondary-left">
                        View Contract
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal keyboard={false} backdrop="static" show={showConfirmDeleteModel} centered onHide={handleCloseConfirmDeleteModal}>
                <Modal.Body style={{ display: "flex", flexDirection: "column" }}>
                    <p>Are you sure you want to delete this File?</p>
                    <span style={{ fontSize: "small" }}>Deleting this file will permenantly remove the file from the system!</span>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setConfirmDeleteModel(false)}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={handleDocumentDelete}>
                        OK
                    </Button>
                </Modal.Footer>
            </Modal>
            <AlertPopUp alertShow={alertShow} alertType={alertType} alertMsg={alertMessage} alertValue={alertValue} alertButtons={alertButtons} />
            {currentPage === 1 &&
                <div className='meter_reports_container'>
                    <div className='d-flex justify-content-between align-items-center flex-wrap'>
                        <div className='d-flex align-items-center gap-3 mb-3'>
                            <h3 className="invoice-heading" >FMS Contracts</h3>
                        </div>
                        <div className='d-flex align-items-center gap-3 mb-3'>
                            
                            <button className='invoice_btn' onClick={changePageNext} style={{ color: "white" }}><span className='generate_invoice'><MdPersonAddAlt1 size={20} style={{marginRight:'5px'}} className="icon-newContact" alt="+" />Add New FMS Contract</span><span className='generate'><MdPersonAddAlt1 style={{ marginRight: "10px" }} alt="+" />Add</span></button>
                        </div>
                    </div>


                    <div className='d-flex gap-3 flex-wrap pb-3'>
                        <select className='commercial-head-dropdown'
                            value={statusFilter}
                            onChange={(e) => { handleStatusFilter(e) }}
                        >
                            <option value='active'>Active</option>
                            <option value='draft'>Draft</option>
                            <option value='pending'>Pending</option>
                            <option value='inactive'>Inactive</option>
                        </select>
                        <div className='fin_man_meter_search_bar_container'>
                            <input type='search' placeholder='Search' value={searchText} className='fin_man_meter_search_bar' onChange={(e) => searchFunc(e.target.value)} />
                            <GoSearch className='fin_man_meter_search_bar_icon' />
                        </div>
                        <button className="add_fac_apply_btn primary-button"
                        // disabled={selectedStateFilter === '' || selectedCityFilter === ''} 

                        onClick={() => {
                            handleApplyFilter()
                        }}
                        >Apply
                    </button>
                    <div className='add_fac_apply_btn secondary-button' 
                    onClick={handleClearFilters}
                    >
                        <span >Clear</span>
                    </div>


                    <div className='table_container_commercial_head' style={{ height: '66%' }}>
                        <table>
                            <thead>
                                <tr className='fin_man_table_head commercial-head-table text-center'>
                                    <th style={{ textWrap: "nowrap" }} className='C-pointer' onClick={() => sortCompanyName()}>
                                        Company Name <FaSort className="icon-sort" alt="edit-icon" /></th>
                                    <th style={{ textWrap: "nowrap" }} className='C-pointer' onClick={() => sortContractName()}>Contract Name <FaSort className="icon-sort" alt="edit-icon" /></th>
                                    <th style={{ textWrap: "nowrap" }} className='C-pointer' onClick={() => sortSpaceName()}>Space Name <FaSort className="icon-sort" alt="edit-icon" /></th>
                                    <th style={{ textWrap: "nowrap" }} className='C-pointer' onClick={() => sortContractNumber()}>Contract No. <FaSort className="icon-sort" alt="edit-icon" /></th>
                                    {/* <th style={{ textWrap: "nowrap" }} className='C-pointer' onClick={() => sortContractType()}>Contract Type <FaSort className="icon-sort" alt="edit-icon" /></th> */}
                                    {/* <th style={{ textWrap: "nowrap" }} className='C-pointer' onClick={() => sortEmail()}>Email <FaSort className="icon-sort" alt="edit-icon" /></th> */}
                                    <th style={{ textWrap: "nowrap" }} className='C-pointer' onClick={() => sortStatus()}>Status <FaSort className="icon-sort" alt="edit-icon" /></th>
                                    <th style={{ textWrap: "nowrap" }} className='C-pointer' onClick={() => sortUpdatedDate()}>Last Updated <FaSort className="icon-sort" alt="edit-icon" /></th>
                                    <th style={{ textWrap: "nowrap" }}>Action</th>

                                </tr>
                            </thead>
                            {tableLoader ? <tbody className='fin_man_table_body'>
                                <tr className='text-center'>
                                    <td colSpan='10'><LoaderSpinner /></td>
                                </tr>
                            </tbody>
                                : contractsList === null ?
                                    <tbody className='fin_man_table_body'>
                                        <tr className='text-center'>
                                            <td colSpan='10'>No records found</td>
                                        </tr>
                                    </tbody>
                                    :
                                    <>
                                        {contractsList && contractsList?.length > 0 ? (

                                            <tbody className='fin_man_table_body'>
                                                {filteredContracts.length > 0 ? (
                                                    filteredContracts.map((each, index) => (
                                                        <tr key={index} className={`table_row ${index % 2 === 0 ? 'even-row' : 'odd-row'}`}>
                                                            <td className='table_text_left'>{each.company_name}</td>
                                                            <td className="table_text_left">{each.contract_name}</td>
                                                            <td className='table_text_left'>{each.space_name}</td>
                                                            <td className="table_text_left">{each.contract_number}</td>
                                                            {/* <td className="table_text_left">{toTitleCase(each.contract_billing_type)}</td> */}
                                                            {/* <td className='table_text_left'>{each.primary_contact_email}</td> */}
                                                            <td className='table_text_left'>{toTitleCase(each.contract_status)}</td>
                                                            <td className='table_text_left' title={each.updated_at}>{timeElapsed(each.updated_at)}</td>
                                                            <td className='text-center' role='button'
                                                                onClick={(event) => {
                                                                    printMousePos(event)
                                                                    setSelectedContract(true)
                                                                }}
                                                                onMouseEnter={(event) => {
                                                                    printMousePos(event)
                                                                }}
                                                            >

                                                                <div className="dropdown" onMouseLeave={() => {
                                                                    setSelectedContract(false)
                                                                }}>
                                                                    <img className='dropbtn' src="./images/icons/horizontalDots.svg" alt="search-icon" />
                                                                    <div className={`dropdown-content ${selectedContract ? '' : 'd-none'}`} style={{ marginLeft: '-37px', marginTop: `${popOverPosition === 'bottom' ? '-10px' : contractType === 'draft' ? '-170px' : '-127px'}` }}>
                                                                        <a onClick={() => { viewSelectedContract(each) }} >
                                                                            <div className="action-items view-icon" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                                                                {/* <img src="./images/icons/ViewEye.svg" alt="view-icon" /> */}
                                                                                < GrView style={{ marginTop: "-14px" }} />
                                                                                <p>View</p>
                                                                            </div>
                                                                        </a>
                                                                        <a onClick={() => { editDraftContract(each) }}>
                                                                            <div className="action-items">
                                                                                <img src="./images/icons/Edit.svg" alt="edit-icon" />
                                                                                <p>Edit</p>
                                                                            </div>
                                                                        </a>
                                                                        {contractType === 'draft' &&
                                                                            <a onClick={() => { handleDeleteClick(each) }}>
                                                                                <div className="action-items">
                                                                                    <img src="./images/icons/delete.svg" alt="delete-icon" />
                                                                                    <p>Delete</p>
                                                                                </div>
                                                                            </a>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </td>

                                                        </tr>

                                                    ))
                                                ) : (
                                                    <tr className='text-center'>
                                                        <td colSpan='10'>No records found</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        ) :
                                            <tbody className='fin_man_table_body'>
                                                <tr className='text-center'>
                                                    <td colSpan='10'>No records found</td>
                                                </tr>
                                            </tbody>
                                        }
                                    </>
                            }
                        </table>
                    </div>
                    <Pagination
                        handledPaginationNextClicked={handledPaginationNextClicked}
                        handledPaginationPrevClicked={handledPaginationPrevClicked}
                        isApplyClicked
                        totalRecords={contractType === "all" ? totalRecordsAc : totalRecordsDc}
                        recordsPerPage={RECORDS_PER_PAGE}
                        currentPaginationPage={contractType === "all" ? currentPaginationPageAc : currentPaginationPageDc}
                    />
                    <Modal keyboard={false} backdrop="static" show={showDeleteModal} onHide={handleCancelClick} centered className="popper-modal">
                        <Modal.Body className="text-center"><h5>{`Are you sure you want to delete contract "${draftContractNumberDelete}"?`}</h5></Modal.Body>
                        <Modal.Footer className="footer">
                            <Button variant="secondary" className="confirmation" onClick={handleCancelClick}>Cancel</Button>
                            <Button variant="secondary" className="confirmation-left" onClick={() => handleProceedClick()}>Proceed</Button>
                        </Modal.Footer>
                    </Modal>
                </div>
                </div>
            }

            {currentPage === 2 ?
                <div className="newContractContainer">
                    <div className="stepsContainer">
                        <div className="stepsTitle">
                            <h6 style={{ padding: "20px 20px 0px 20px", lineHeight: "0px" }}>FMS Contract Creation Steps</h6>
                            <span style={{ fontSize: "10px", padding: "20px", lineHeight: "0px" }}><MdInfoOutline /> Please fill all the fields in every step to create a Contract</span>
                        </div>
                        <div className="listOfCards">
                            {steps && steps.map((item, index) => {
                                return (
                                    <div className={`${currentPage - 1 === index + 1 ? 'stepsCardActive' : 'stepsCard'}`}>
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                            <span style={{ fontWeight: "bold", fontSize: "medium" }}>{item.name}</span>
                                            {
                                                index === 0 && contractName && isContractNameValid && contractStatus && contactName && !duplicateContractNameError && !duplicateContractNumberError
                                                    && contractNumber && isContractNumberValid && billingEntity && billingEntity !== 'Select'
                                                    && isContactNameValid && email && isValidEmail &&
                                                    gstNumber && companyName && panName && registeredStreetAddress &&
                                                    registeredStreetAddressLane2 &&
                                                    registeredCity && registeredStateProvince && registeredPostalCode &&
                                                    isValidGstNumber
                                                    //  && cinNumber 
                                                    && isCinValid && contactValidationsFunc()
                                                    ?
                                                    <img src={"./images/icons/CirclecircleWithTick.svg"} style={{ height: "16px" }} alt="ok" />
                                                    :
                                                    <>
                                                    
                                                    {
                                                        index === 0 ?
                                                        <MdErrorOutline title="Please fill all the fields in this step" style={{color:"var(--secondaryLight)"}} fontSize={18} />
                                                        :
                                                        null
                                                    }
                                                    </>
                                            }
                                            {
                                                index === 1 && billingStreetAddress && billingStreetAddressLane2 && billingCity &&
                                                    billingStateProvince && billingPostalCode && isPincodeValid && shippingStreetAddress && shippingStreetAddressLane2 && shippingCity
                                                    && shippingStateProvince && shippingPostalCode && isShippingPincodeValid
                                                    ?
                                                    <img src={"./images/icons/CirclecircleWithTick.svg"} style={{ height: "16px" }} alt="ok" />
                                                    :
                                                    <>

                                                        {
                                                            index === 1 ?
                                                                <MdErrorOutline title="Please fill all the fields in this step" style={{ color: "orange" }} fontSize={18} />
                                                                :
                                                                null
                                                        }
                                                    </>
                                            }
                                            {
                                                index === 2 && spaceName && isSpaceNameValid && contractStartDate && contractStartDate !== '' &&
                                                    contractEndDate && contractEndDate !== ''
                                                    && expireNotification &&
                                                    gracePeriod >= 0 && termsAndConditions && !slfValidationsFunc()
                                                    ?
                                                    <img src={"./images/icons/CirclecircleWithTick.svg"} style={{ height: "16px" }} alt="ok" />
                                                    :
                                                    <>

                                                        {
                                                            index === 2 ?
                                                                <MdErrorOutline title="Please fill all the fields in this step" style={{ color: "orange" }} fontSize={18} />
                                                                :
                                                                null
                                                        }
                                                    </>
                                            }



                                        </div>

                                        <span style={{ fontSize: "small", marginTop: "10px" }}>{item.description}</span>
                                        {
                                            checkmarkVisibilityCalculationPage2()
                                                ?
                                                null :
                                                <>
                                                    {
                                                        index === 0 ?
                                                            <spam style={{ fontSize: "10px", marginTop: "10px", color: "red" }}>
                                                                Missing Fields: <br />{missingFieldsCalculatePage2()}
                                                            </spam>
                                                            :
                                                            null
                                                    }
                                                </>
                                        }

                                        {
                                            checkmarkVisibilityCalculationPage3()
                                                ?
                                                null :
                                                <>
                                                    {
                                                        index === 1 ?
                                                            <spam style={{ fontSize: "10px", marginTop: "10px", color: "red" }}>
                                                                Missing Fields: <br />{missingFieldsCalculatePage3()}
                                                            </spam>
                                                            :
                                                            null
                                                    }
                                                </>
                                        }

                                        {
                                            checkmarkVisibilityCalculationPage4()
                                                ?
                                                null :
                                                <>
                                                    {
                                                        index === 2 ?
                                                            <spam style={{ fontSize: "10px", marginTop: "10px", color: "red" }}>
                                                                Missing Fields: <br />{missingFieldsCalculatePage4()}
                                                            </spam>
                                                            :
                                                            null
                                                    }
                                                </>
                                        }
                                    </div>
                                )
                            })

                            }

                        </div>
                    </div>
                    { }
                    <div className="infoContainer">
                        <div>
                            {steps && steps.map((item, index) => {
                                return (
                                    <>
                                        {currentPage - 1 === index + 1 ?
                                            <div className="infoTitle">
                                                <h6 style={{ padding: "20px", lineHeight: "0px" }}>{item.name}</h6>
                                                <h6 style={{ padding: "20px", lineHeight: "0px" }}>{index + 1} of {steps.length}</h6>
                                            </div>

                                            : null}
                                    </>
                                )
                            })}
                        </div>

                        <div className="infoBody">

                            <div>
                                <h7 style={{ fontWeight: "bold" }}>Contract Details</h7>
                                <div className="infoBodyInputs">
                                    <div className="responsiveInputSection">
                                        <div >
                                            <label className='add-facility-modal-label'>Contract Name <span style={{ color: "red" }}>*</span></label>
                                            <input type='text' value={contractName}
                                                disabled={viewClicked || editCompleteContractClicked}
                                                onChange={handleContractNameChange}
                                                className='form-control responsive-add-facility-input-fields' />
                                            {!isContractNameValid && <span className='input-error-text'>Must be min of 3 to max of 200 characters</span>}
                                            {isContractNameValid && duplicateContractNameError && (<span className="input-error-text">Contract Name already exists!</span>)}
                                        </div>
                                        <div>
                                            <label className='add-facility-modal-label'>Contract Number {<span style={{ color: "red" }}>*</span>}</label>
                                            <input
                                                disabled={viewClicked || editCompleteContractClicked}
                                                type='text' value={contractNumber}
                                                onChange={handleContractNumberChange}
                                                className='form-control responsive-add-facility-input-fields' />
                                            {!isContractNumberValid && <span className="input-error-text">Must be min of 3 to max of 200 characters</span>}
                                            {isContractNumberValid && duplicateContractNumberError && (<span className='input-error-text'> Contract Number already exists!</span>)}
                                        </div>
                                        <div >
                                            <label className='add-facility-modal-label' disabled={viewClicked}>Contract Status {<span style={{ color: "red" }}>*</span>}</label>
                                            <select disabled={viewClicked || !isSubmitActive()} value={contractStatus} onChange={(e) => setContractStatus(e.target.value)} className='form-select responsive-add-facility-input-fields'>
                                                <option value="draft">Draft</option>
                                                <option value="pending">Pending</option>
                                                <option value="active">Active</option>
                                                <option value="inactive">Inactive</option>
                                            </select>
                                        </div>

                                    </div>
                                    <div className="responsiveInputSection">
                                        <div>
                                            <label className='add-facility-modal-label'>Billing Entity {<span style={{ color: "red" }}>*</span>}</label>
                                            <select disabled={viewClicked} className='form-select responsive-add-facility-input-fields' value={billingEntity} onChange={(e) => {
                                                setBillingEntity(e.target.value);
                                            }}>
                                                <option hidden>Select</option>
                                                {
                                                    billingEntities?.map((entity, index) => (
                                                        <option key={entity.id} value={entity.partner_company_id}>{toTitleCase(entity.company_name)}</option>
                                                    ))
                                                }

                                            </select>
                                        </div>
                                        <div>
                                            <label className='add-facility-modal-label'>Facility {<span style={{ color: "red" }}>*</span>}</label>
                                            <input disabled={true} type='text' value={localStorage.getItem("selected_facility_name")}
                                                onChange={handleContractNumberChange}
                                                className='form-control responsive-add-facility-input-fields'
                                            />

                                        </div>


                                    </div>


                                </div>
                            </div>
                            <hr></hr>
                            <div>
                                <h7 style={{ fontWeight: "bold" }}>Company Details</h7>
                                <div className="infoBodyInputs">

                                    <div className="responsiveInputSection">
                                        <div style={{ display: "flex", flexDirection: "row" }}>
                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                <label className='add-facility-modal-label'>GST Number {<span style={{ color: "red" }}>*</span>}</label>
                                                <input disabled={viewClicked || editCompleteContractClicked} type='text' value={gstNumber} onChange={handleGstNumberChange} onKeyDown={handleKeyPressForGst} className='form-control ' style={{ width: "90%", border: "0.5px solid #9D9D9C" }} />
                                                {!isValidGstNumber && <span className="input-error-text">Invalid GST number</span>}
                                            </div>
                                            {/* >>> */}
                                            {
                                                !viewClicked ? (
                                                    <div style={{ marginBottom: "0px", display: "flex", alignItems: "start", marginTop: "20px" }}>
                                                        <div
                                                            style={{
                                                                background: "grey",
                                                                padding: "9px 10px",
                                                                marginLeft: "-20px",
                                                                borderRadius: "5px",
                                                                opacity: gstNumber === '' || !isValidGstNumber ? 0.3 : 1,
                                                                pointerEvents: gstNumber === '' || !isValidGstNumber ? 'none' : 'auto'
                                                            }}
                                                            className="C-pointer"
                                                            onClick={() => {
                                                                if (gstNumber !== '' && isValidGstNumber) {
                                                                    setGstLoader(true);
                                                                    // dispatch(GstNumberDetails(gstNumber))
                                                                    handleGstClick(gstNumber);
                                                                }
                                                            }}
                                                        >
                                                            {
                                                                gstLoader && !errorValue ? (
                                                                    <GstLoader />
                                                                ) : (
                                                                    <FaSearch color="white" size={20} style={{ fontWeight: "bolder" }} />
                                                                )
                                                            }
                                                        </div>
                                                    </div>
                                                ) : null
                                            }
                                        </div>
                                        <div>
                                            <label className='add-facility-modal-label'>CIN
                                                {/* {<span style={{ color: "red" }}>*</span>} */}
                                            </label>
                                            <input type='text' disabled={viewClicked} value={cinNumber} onChange={handleCinNumberChange} className='form-control responsive-add-facility-input-fields' />
                                            {!isCinValid && <span className="input-error-text">Invalid CIN</span>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="infoBodyInputs">
                                    <div className="responsiveInputSection">
                                        <div>
                                            <label className='add-facility-modal-label'>Company Name {<span style={{ color: "red" }}>*</span>}</label>
                                            <input type='text' disabled={true} value={companyName} onChange={(e) => setCompanyName(e.target.value)} className='form-control responsive-add-facility-input-fields' />
                                        </div>
                                        <div >
                                            <label className='add-facility-modal-label'>PAN {<span style={{ color: "red" }}>*</span>}</label>
                                            <input type='text' disabled={true} value={panName} onChange={(e) => setPanName(e.target.value)} className='form-control responsive-add-facility-input-fields' />
                                        </div>
                                        <div>
                                            <label className='add-facility-modal-label'>Street Address {<span style={{ color: "red" }}>*</span>}</label>
                                            <input type='text' disabled={true} value={registeredStreetAddress} onChange={(e) => setRegisteredStreetAddress(e.target.value)} className='form-control responsive-add-facility-input-fields' />
                                        </div>
                                    </div>
                                    <div className="responsiveInputSection">

                                        <div >
                                            <label className='add-facility-modal-label'>Street Address Lane 2 {<span style={{ color: "red" }}>*</span>}</label>
                                            <input type='text' disabled={true} value={registeredStreetAddressLane2} onChange={(e) => setRegisteredStreetAddressLane2(e.target.value)} className='form-control responsive-add-facility-input-fields' />
                                        </div>
                                        <div >
                                            <label className='add-facility-modal-label'>City {<span style={{ color: "red" }}>*</span>}</label>
                                            <input type='text' disabled={true} value={registeredCity} onChange={(e) => setRegisteredCity(e.target.value)} className='form-control responsive-add-facility-input-fields' />
                                        </div>
                                        <div >
                                            <label className='add-facility-modal-label'>State {<span style={{ color: "red" }}>*</span>}</label>
                                            <input type='text' disabled={true} value={registeredStateProvince} onChange={(e) => setRegisteredStateProvince(e.target.value)} className='form-control responsive-add-facility-input-fields' />
                                        </div>
                                    </div>
                                    <div className="responsiveInputSection">

                                        <div >
                                            <label className='add-facility-modal-label'>Pincode {<span style={{ color: "red" }}>*</span>}</label>
                                            <input type='text' disabled={true} value={registeredPostalCode} onChange={(e) => setRegisteredPostalCode(e.target.value)} className='form-control responsive-add-facility-input-fields' />
                                        </div>

                                    </div>
                                </div>
                                <hr></hr>
                                <h7 style={{ fontWeight: "bold" }}>Primary Contact Information</h7>
                                <div className="responsiveInputSection">
                                    <div >
                                        <label className='add-facility-modal-label'>Contact Name {<span style={{ color: "red" }}>*</span>}</label>
                                        <input type='text' value={contactName} disabled={viewClicked}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                const formattedInput = value.replace(/[^A-Za-z\s]/g, '');
                                                const trimmedInput = eleminateSpacesAtStartOfInputField(formattedInput);

                                                if (trimmedInput.length !== 0 && (trimmedInput.length < 3 || trimmedInput.length > 200)) {
                                                    setIsContactNameValid(false);
                                                } else {
                                                    setIsContactNameValid(true);
                                                }

                                                setContactName(trimmedInput);
                                            }} className='form-control responsive-add-facility-input-fields' />
                                        {!isContactNameValid && <span className='input-error-text'>Must be min of 3 to max of 200 characters</span>}
                                    </div>
                                    <div >
                                        <label className='add-facility-modal-label'>Phone Number</label>
                                        <input type='text' value={phoneNumber}
                                            disabled={viewClicked}
                                            onChange={(e) => {
                                                const input = e.target.value;
                                                const formattedInput = input.replace(/\D/g, '');
                                                const trimmedInput = formattedInput.slice(0, 15);
                                                // if (trimmedInput.length === 0 || trimmedInput.length >= 10) {
                                                //     setIsValidPhone(true);

                                                // } else {
                                                //     setIsValidPhone(false);
                                                // }
                                                setPhoneNumber(trimmedInput);
                                            }}
                                            className='form-control responsive-add-facility-input-fields' />
                                        {!isValidPhone && <span className="input-error-text">Invalid Phone Number</span>}

                                    </div>
                                    <div >
                                        <label className='add-facility-modal-label'>Email {<span style={{ color: "red" }}>*</span>}</label>
                                        <input type='text' disabled={viewClicked} value={email}
                                            onChange={handleEmailChange}
                                            className='form-control responsive-add-facility-input-fields' />
                                        {!isValidEmail && <span className="input-error-text">Invalid email address</span>}
                                    </div>

                                </div>
                                <hr></hr>
                                <div style={{ display: "flex", justifyContent: "space-between", }}>
                                    <h7 style={{ fontWeight: "bold" }}>Secondary Contact Information</h7>
                                    {!viewClicked ?
                                        <span style={{
                                            textDecoration: "underline",
                                            cursor: "pointer",
                                            opacity: (listOfContactsValidation[listOfContactsValidation.length - 1]?.isValidEmail === true &&
                                                listOfContacts[listOfContacts.length - 1].email !== '') ? '100%' : '50%'
                                        }}
                                            className="C-pointer"
                                            onClick={() => {
                                                if (
                                                    listOfContactsValidation[listOfContactsValidation.length - 1]?.isValidEmail === true &&
                                                    listOfContacts[listOfContacts.length - 1].email !== ''
                                                ) {
                                                    handleAddAnotherContact()
                                                    handleAddAnotherContactValidation()
                                                }

                                            }} > {listOfContactsValidation[listOfContactsValidation.length - 1]?.isValidEmail === true &&
                                                listOfContacts[listOfContacts.length - 1].email !== ''}Add another contact</span>
                                        :
                                        null}
                                </div>

                                {listOfContacts && listOfContacts?.map((contact, index) => (
                                    <div key={index} className="infoBodyInputs">
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", marginTop: "10px" }}>
                                            <p style={{ fontWeight: "bold" }}>Contact {index + 1}</p>
                                            {index !== 0 && !viewClicked ? (
                                                <div>
                                                    <img src="./images/icons/crossWithCircle.svg" className="C-pointer" alt="cross"
                                                        onClick={() => {
                                                            deleteSpecificContact(index, contact)
                                                        }} />
                                                </div>
                                            ) : null}
                                        </div>
                                        <div className="responsiveInputSection" style={{ marginTop: "0px" }}>
                                            <div >
                                                <label className='add-facility-modal-label'>Contact Name {<span style={{ color: "red" }}>*</span>}</label>
                                                <input type='text' disabled={viewClicked} className='form-control responsive-add-facility-input-fields' value={contact.name}
                                                    onChange={(e) => {
                                                        const updatedContacts = [...listOfContacts];
                                                        const updatedContactsValidation = [...listOfContactsValidation];
                                                        const rawInput = e.target.value;
                                                        const formattedInput = rawInput.replace(/[^A-Za-z\s]/g, '');
                                                        const processedInput = eleminateSpacesAtStartOfInputField(formattedInput);
                                                        updatedContacts[index].name = processedInput;
                                                        if (processedInput.length === 0 || processedInput.length < 3 || processedInput.length > 200) {
                                                            updatedContactsValidation[index].isContactNameValid = false;
                                                        } else {
                                                            updatedContactsValidation[index].isContactNameValid = true;
                                                        }
                                                        setListOfContacts(updatedContacts);
                                                        setListOfContactsValidation(updatedContactsValidation);
                                                    }}
                                                />
                                                {!listOfContactsValidation[index]?.isContactNameValid && <span className="input-error-text">Must be min of 3 to max of 200 characters</span>}
                                            </div>
                                            <div >
                                                <label className='add-facility-modal-label'>Designation </label>
                                                <input disabled={viewClicked} type='text' className='form-control responsive-add-facility-input-fields' value={contact.designation}
                                                    onChange={(e) => {
                                                        const updatedContacts = [...listOfContacts];
                                                        const updatedContactsValidation = [...listOfContactsValidation];

                                                        const input = e.target.value;
                                                        const formattedInput = input.replace(/[^a-zA-Z ]+/g, '');
                                                        const cleanedInput = eleminateSpacesAtStartOfInputField(formattedInput);
                                                        if (cleanedInput.length !== 0 && (cleanedInput.length > 200)) {
                                                            updatedContactsValidation[index].isDesignationValid = false;
                                                        } else {
                                                            updatedContactsValidation[index].isDesignationValid = true;
                                                        }
                                                        updatedContacts[index].designation = cleanedInput;

                                                        setListOfContacts(updatedContacts);
                                                        setListOfContactsValidation(updatedContactsValidation);
                                                    }} />
                                                {!listOfContactsValidation[index]?.isDesignationValid && <span className="input-error-text">Must be max of 200 characters</span>}
                                            </div>
                                            <div >
                                                <label className='add-facility-modal-label'>Phone Number </label>
                                                <input type='text' disabled={viewClicked} className='form-control responsive-add-facility-input-fields' value={contact.phone_number}
                                                    onChange={(e) => {
                                                        const updatedContactsValidation = [...listOfContactsValidation]
                                                        const input = e.target.value;
                                                        const updatedContacts = [...listOfContacts];
                                                        const formattedInput = input.replace(/\D/g, '');
                                                        const trimmedInput = formattedInput.slice(0, 15);
                                                        updatedContactsValidation[index].isValidPhone = trimmedInput.length === 0 || (trimmedInput.length >= 10 && trimmedInput.length <= 15);
                                                        updatedContactsValidation[index].errorMsg = trimmedInput.length < 10 && trimmedInput.length > 0 ? 'Invalid phone number' : '';

                                                        updatedContacts[index].phone_number = trimmedInput
                                                        setListOfContactsValidation(updatedContactsValidation)
                                                        setListOfContacts(updatedContacts);
                                                    }} />
                                                {!listOfContactsValidation[index]?.isValidPhone && <span className="input-error-text">Invalid Phone Number</span>}
                                            </div>
                                        </div>
                                        <div className="responsiveInputSection">
                                            <div >
                                                <label className='add-facility-modal-label'>Email {<span style={{ color: "red" }}>*</span>}</label>
                                                <input type='text' disabled={viewClicked} className='form-control responsive-add-facility-input-fields' value={contact.email}
                                                    onChange={(e) => handleEmailUpdateChange(e, index)} />
                                                {!listOfContactsValidation[index]?.isValidEmail && <span className="input-error-text">Invalid email address</span>}
                                            </div>

                                        </div>
                                        <hr></hr>
                                    </div>
                                ))}

                            </div>


                        </div>

                        <div className="infoFotter">
                            {!viewClicked && currentPage !== 1 ?
                                <>
                                    {currentPage <steps.length + 1 && (
                                        <button className="infoNextBtn secondary-button" style={{ marginRight: "20px" }} onClick={handleShowCloseConfirmationModal}>Close</button>
                                    )}
                                    {/* <button className="infoNextBtn" style={{ marginRight: "20px" }} onClick={changePagePrev}>Back</button> */}
                                    {
                                        !editCompleteContractClicked ?
                                            <button className="infoNextBtn primary-button" onClick={saveAndContinue}
                                                style={checkSaveandContinueValidation() ? { opacity: '50%' } : { opacity: '100%' }}
                                                disabled={checkSaveandContinueValidation()}
                                            >Save & Continue</button> :
                                            <button className="infoNextBtn primary-button" style={{ marginRight: "20px" }} onClick={() => changePageNext()} >{"Next"}</button>
                                    }
                                </>
                                :
                                <>
                                    {currentPage < steps.length + 1 ? <button className="infoNextBtn secondary-button" style={{ marginRight: "20px" }} onClick={() => closeClicked()} >Close</button> : null}
                                    {/* <button className="infoNextBtn" style={{ marginRight: "20px" }} onClick={changePagePrev}>Back</button> */}
                                    <button className="infoNextBtn primary-button" style={{ marginRight: "20px" }} onClick={() => changePageNext()} >{currentPage === steps.length ? "Close" : "Next"}</button>
                                </>
                            }
                        </div>
                        <Modal
                            backdrop="static"
                            show={showCloseConfirmationModal} onHide={handleCloseCloseConfirmationModal}
                            centered className="popper-modal">
                            <Modal.Body className="text-center">
                                <h5>Are you sure you want to Close?</h5>
                            </Modal.Body>
                            <Modal.Footer className="footer">
                                <Button variant="secondary" className="confirmation" onClick={handleCloseCloseConfirmationModal}>  Cancel </Button>
                                <Button variant="secondary" className="confirmation-left" onClick={handleCloseProceed} > Proceed</Button>
                            </Modal.Footer></Modal>
                        {/*modal for confirmation*/}
                        < Modal show={showConfirmationModal} onHide={handleCloseConfirmationModal} centered className="popper-modal" >
                            <Modal.Body className="text-center" ><h5>Are you sure you want to save this as Draft?</h5></Modal.Body>
                            <Modal.Footer className="footer">
                                <Button variant="secondary" className="confirmation" onClick={handleCloseConfirmationModal}>Cancel</Button>
                                <Button variant="secondary" className="confirmation-left" onClick={handleSaveAsDraftConfirmation}>Proceed</Button>
                            </Modal.Footer>
                        </Modal>
                        {/* modal for save as draft page 1 */}

                    </div>
                </div>
                :
                null

            }

            {currentPage === 3 ?
                <div className="newContractContainer">
                    <div className="stepsContainer">
                        <div className="stepsTitle">
                            <h6 style={{ padding: "20px 20px 0px 20px", lineHeight: "0px" }}>Contract Creation Steps</h6>
                            <span style={{ fontSize: "10px", padding: "20px", lineHeight: "0px" }}><MdInfoOutline /> Please fill all the fields in every step to create a Contract</span>
                        </div>
                        <div className="listOfCards">
                            {steps && steps.map((item, index) => {
                                return (
                                    <div className={`${currentPage - 1 === index + 1 ? 'stepsCardActive' : 'stepsCard'}`}>
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                            <span style={{ fontWeight: "bold", fontSize: "medium" }}>{item.name}</span>
                                            {
                                                index === 0 && contractName && isContractNameValid && contractStatus && contactName && !duplicateContractNameError && !duplicateContractNumberError
                                                    && contractNumber && isContractNumberValid && billingEntity && billingEntity !== 'Select'
                                                    && isContactNameValid && email && isValidEmail &&
                                                    gstNumber && companyName && panName && registeredStreetAddress &&
                                                    registeredStreetAddressLane2 &&
                                                    registeredCity && registeredStateProvince && registeredPostalCode &&
                                                    isValidGstNumber
                                                    //  && cinNumber 
                                                    && isCinValid && contactValidationsFunc()
                                                    ?
                                                    <img src={"./images/icons/CirclecircleWithTick.svg"} style={{ height: "16px" }} alt="ok" />
                                                    :
                                                    <>

                                                        {
                                                            index === 0 ?
                                                                <MdErrorOutline title="Please fill all the fields in this step" style={{ color: "orange" }} fontSize={18} />
                                                                :
                                                                null
                                                        }
                                                    </>
                                            }
                                            {
                                                index === 1 && billingStreetAddress && billingStreetAddressLane2 && billingCity &&
                                                    billingStateProvince && billingPostalCode && isPincodeValid && shippingStreetAddress && shippingStreetAddressLane2 && shippingCity
                                                    && shippingStateProvince && shippingPostalCode && isShippingPincodeValid
                                                    ?
                                                    <img src={"./images/icons/CirclecircleWithTick.svg"} style={{ height: "16px" }} alt="ok" />
                                                    :
                                                    <>

                                                        {
                                                            index === 1 ?
                                                                <MdErrorOutline title="Please fill all the fields in this step" style={{ color: "orange" }} fontSize={18} />
                                                                :
                                                                null
                                                        }
                                                    </>
                                            }
                                            {
                                                index === 2 && spaceName && isSpaceNameValid && contractStartDate && contractStartDate !== '' &&
                                                    contractEndDate && contractEndDate !== ''
                                                    && expireNotification &&
                                                    gracePeriod >= 0 && termsAndConditions && !slfValidationsFunc()
                                                    ?
                                                    <img src={"./images/icons/CirclecircleWithTick.svg"} style={{ height: "16px" }} alt="ok" />
                                                    :
                                                    <>

                                                        {
                                                            index === 2 ?
                                                                <MdErrorOutline title="Please fill all the fields in this step" style={{ color: "orange" }} fontSize={18} />
                                                                :
                                                                null
                                                        }
                                                    </>
                                            }
                                        </div>
                                        <span style={{ fontSize: "small", marginTop: "10px" }}>{item.description}</span>

                                        {
                                            checkmarkVisibilityCalculationPage2()
                                                ?
                                                null :
                                                <>
                                                    {
                                                        index === 0 ?
                                                            <spam style={{ fontSize: "10px", marginTop: "10px", color: "red" }}>
                                                                Missing Fields: <br />{missingFieldsCalculatePage2()}
                                                            </spam>
                                                            :
                                                            null
                                                    }
                                                </>
                                        }

                                        {
                                            checkmarkVisibilityCalculationPage3()
                                                ?
                                                null :
                                                <>
                                                    {
                                                        index === 1 ?
                                                            <spam style={{ fontSize: "10px", marginTop: "10px", color: "red" }}>
                                                                Missing Fields: <br />{missingFieldsCalculatePage3()}
                                                            </spam>
                                                            :
                                                            null
                                                    }
                                                </>
                                        }

                                        {
                                            checkmarkVisibilityCalculationPage4()
                                                ?
                                                null :
                                                <>
                                                    {
                                                        index === 2 ?
                                                            <spam style={{ fontSize: "10px", marginTop: "10px", color: "red" }}>
                                                                Missing Fields: <br />{missingFieldsCalculatePage4()}
                                                            </spam>
                                                            :
                                                            null
                                                    }
                                                </>
                                        }

                                    </div>
                                )
                            })

                            }

                        </div>
                    </div>

                    <div className="infoContainer">
                        <div>
                            {steps && steps.map((item, index) => {
                                return (
                                    <>
                                        {currentPage - 1 === index + 1 ?
                                            <div className="infoTitle">
                                                <h6 style={{ padding: "20px", lineHeight: "0px" }}>{item.name}</h6>

                                                <h6 style={{ padding: "20px", lineHeight: "0px" }}>{index + 1} of {steps.length}</h6>
                                            </div>

                                            : null}
                                    </>
                                )
                            })}
                        </div>


                        <div className="infoBody">
                            <div>
                                <div style={{ display: "flex", justifyContent: "space-between", }}>
                                    <h7 style={{ fontWeight: "bold" }}>Billing Address</h7>
                                    {
                                        !viewClicked ?
                                            <span style={{ textDecoration: "underline", }} className="C-pointer" onClick={sameAsRegisteredAddress}>Same as GST address</span>
                                            :
                                            null
                                    }
                                </div>
                                <div className="infoBodyInputs">
                                    <div className="responsiveInputSection">
                                        <div>
                                            <label className='add-facility-modal-label'>Street Address {<span style={{ color: "red" }}>*</span>}</label>
                                            <input disabled={viewClicked} type='text' value={billingStreetAddress} onChange={(e) => setBillingStreetAddress(e.target.value)} className='form-control responsive-add-facility-input-fields' />
                                        </div>
                                        <div >
                                            <label className='add-facility-modal-label'>Street Address Lane 2 {<span style={{ color: "red" }}>*</span>}</label>
                                            <input disabled={viewClicked} type='text' value={billingStreetAddressLane2} onChange={(e) => setBillingStreetAddressLane2(e.target.value)} className='form-control responsive-add-facility-input-fields' />
                                        </div>
                                        <div >
                                            <label className='add-facility-modal-label'>City {<span style={{ color: "red" }}>*</span>}</label>
                                            <input disabled={viewClicked} type='text' value={billingCity} onChange={(e) => setBillingCity(e.target.value)} className='form-control responsive-add-facility-input-fields' />
                                        </div>
                                    </div>
                                    <div className="responsiveInputSection">
                                        <div >
                                            <label className='add-facility-modal-label'>State {<span style={{ color: "red" }}>*</span>}</label>
                                            <input disabled={true} type='text' value={billingStateProvince} onChange={(e) => setBillingStateProvince(e.target.value)} className='form-control responsive-add-facility-input-fields' />
                                        </div>
                                        <div >
                                            <label className='add-facility-modal-label'>Pincode {<span style={{ color: "red" }}>*</span>}</label>
                                            <input disabled={viewClicked} type='text' value={billingPostalCode} onChange={(e) => {
                                                const input = e.target.value
                                                const formattedInput = input.replace(/[^0-9]/g, '')
                                                const trimmedInput = formattedInput.trim();
                                                if (trimmedInput === '') {
                                                    setIsPincodeValid(true);
                                                } else if (trimmedInput.length !== 6) {
                                                    setIsPincodeValid(false);
                                                } else {
                                                    setIsPincodeValid(true);
                                                }
                                                setBillingPostalCode(trimmedInput)
                                            }} className='form-control responsive-add-facility-input-fields' />
                                            {!isPincodeValid && <span className="input-error-text">Invalid pincode</span>}
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <hr></hr>
                            <div style={{ display: "flex", justifyContent: "space-between", }}>
                                <h7 style={{ fontWeight: "bold" }}>Shipping Address</h7>
                                {
                                    !viewClicked ?
                                        <span style={{ textDecoration: "underline", }} className="C-pointer" onClick={sameAsBillingAddress}>Same as Billing address</span>
                                        :
                                        null
                                }
                            </div>
                            <div>
                                <div className="infoBodyInputs">
                                    <div className="responsiveInputSection">
                                        <div>
                                            <label className='add-facility-modal-label'>Street Address {<span style={{ color: "red" }}>*</span>}</label>
                                            <input disabled={viewClicked} type='text' value={shippingStreetAddress} onChange={(e) => setShippingStreetAddress(e.target.value)} className='form-control responsive-add-facility-input-fields' />
                                        </div>
                                        <div >
                                            <label className='add-facility-modal-label'>Street Address Lane 2 {<span style={{ color: "red" }}>*</span>}</label>
                                            <input disabled={viewClicked} type='text' value={shippingStreetAddressLane2} onChange={(e) => setShippingStreetAddressLane2(e.target.value)} className='form-control responsive-add-facility-input-fields' />
                                        </div>
                                        <div >
                                            <label className='add-facility-modal-label'>City {<span style={{ color: "red" }}>*</span>}</label>
                                            <input disabled={viewClicked} type='text' value={shippingCity} onChange={(e) => setShippingCity(e.target.value)} className='form-control responsive-add-facility-input-fields' />
                                        </div>
                                    </div>
                                    <div className="responsiveInputSection">
                                        <div >
                                            <label className='add-facility-modal-label'>State {<span style={{ color: "red" }}>*</span>}</label>
                                            <input disabled={true} type='text' value={shippingStateProvince} onChange={(e) => setShippingStateProvince(e.target.value)} className='form-control responsive-add-facility-input-fields' />
                                        </div>
                                        <div >
                                            <label className='add-facility-modal-label'>Pincode {<span style={{ color: "red" }}>*</span>}</label>
                                            <input disabled={viewClicked} type='text' value={shippingPostalCode} onChange={(e) => {
                                                const input = e.target.value
                                                const formattedInput = input.replace(/[^0-9]/g, '')
                                                const trimmedInput = formattedInput.trim();
                                                if (trimmedInput === '') {
                                                    setIsShippingPincodeValid(true);
                                                } else if (trimmedInput.length !== 6) {
                                                    setIsShippingPincodeValid(false);
                                                } else {
                                                    setIsShippingPincodeValid(true);
                                                }
                                                setShippingPostalCode(trimmedInput)
                                            }} className='form-control responsive-add-facility-input-fields' />
                                            {!isShippingPincodeValid && <span className="input-error-text">Invalid pincode</span>}
                                        </div>

                                    </div>
                                </div>
                                <hr></hr>


                            </div>
                            <div>

                            </div>
                            <Modal keyboard={false} backdrop="static" show={showDeleteContractContact} onHide={() => { setShowDeleteContractContact(false) }} centered className="popper-modal">
                                <Modal.Body className="text-center">
                                    <h5>{`Are you sure you want to delete this contact?`}</h5>
                                </Modal.Body>
                                <Modal.Footer className="footer">
                                    <Button variant="secondary" className="confirmation" onClick={() => { setShowDeleteContractContact(false) }}>Cancel</Button>
                                    <Button variant="secondary" className="confirmation-left" onClick={() => handleConfirmDeleteContractContact()}>Proceed</Button>
                                </Modal.Footer>
                            </Modal>
                        </div>
                        <div className="infoFotter">
                            {!viewClicked ?
                                <>
                                     {currentPage <steps.length + 1 && (
                                        <button className="infoNextBtn secondary-button" style={{ marginRight: "20px" }} onClick={handleShowCloseConfirmationModal}>Close</button>
                                    )}
                                    <button className="infoNextBtn secondary-button" style={{ marginRight: "20px" }} onClick={changePagePrev}>Back</button>
                                    
                                    {
                                        !editCompleteContractClicked ?
                                            <button className="infoNextBtn primary-button" onClick={saveAndContinue}
                                                style={checkSaveandContinueValidation() ? { opacity: '50%' } : { opacity: '100%' }}
                                                disabled={checkSaveandContinueValidation()}
                                            >Save & Continue</button> :
                                            <button className="infoNextBtn primary-button" style={{ marginRight: "20px" }} onClick={() => changePageNext()} >{"Next"}</button>
                                    }
                                </>
                                :
                                <>
                                    {currentPage < steps.length + 1 ? <button className="infoNextBtn secondary-button" style={{ marginRight: "20px" }} onClick={() => closeClicked()} >Close</button> : null}
                                    <button className="infoNextBtn secondary-button" style={{ marginRight: "20px" }} onClick={changePagePrev}>Back</button>
                                    <button className="infoNextBtn primary-button" style={{ marginRight: "20px" }} onClick={() => changePageNext()} >{currentPage === steps.length +1 ? "Close" : "Next"}</button>
                                </>
                            }
                        </div>
                        <Modal
                            backdrop="static"
                            show={showCloseConfirmationModal} onHide={handleCloseCloseConfirmationModal}
                            centered className="popper-modal">
                            <Modal.Body className="text-center">
                                <h5>Are you sure you want to Close?</h5>
                            </Modal.Body>
                            <Modal.Footer className="footer">
                                <Button variant="secondary" className="confirmation" onClick={handleCloseCloseConfirmationModal}>  Cancel </Button>
                                <Button variant="secondary" className="confirmation-left" onClick={handleCloseProceed} > Proceed</Button>
                            </Modal.Footer></Modal>
                        {/*modal for confirmation*/}
                        < Modal show={showConfirmationModal} onHide={handleCloseConfirmationModal} centered className="popper-modal" >
                            <Modal.Body className="text-center" ><h5>Are you sure you want to save this as Draft?</h5></Modal.Body>
                            <Modal.Footer className="footer">
                                <Button variant="secondary" className="confirmation" onClick={handleCloseConfirmationModal}>Cancel</Button>
                                <Button variant="secondary" className="confirmation-left" onClick={handleSaveAsDraftConfirmation}>Proceed</Button>
                            </Modal.Footer>
                        </Modal>
                    </div>
                </div> : null

            }

            {currentPage === 4 ?
                <div className="newContractContainer">
                    <div className="stepsContainer">
                        <div className="stepsTitle">
                            <h6 style={{ padding: "20px 20px 0px 20px", lineHeight: "0px" }}>Contract Creation Steps</h6>
                            <span style={{ fontSize: "10px", padding: "20px", lineHeight: "0px" }}><MdInfoOutline /> Please fill all the fields in every step to create a Contract</span>

                        </div>
                        <div className="listOfCards">
                            {steps && steps.map((item, index) => {
                                return (
                                    <div className={`${currentPage - 1 === index + 1 ? 'stepsCardActive' : 'stepsCard'}`}>
                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                            <span style={{ fontWeight: "bold", fontSize: "medium" }}>{item.name}</span>

                                            {
                                                index === 0 && contractName && isContractNameValid && contractStatus && contactName && !duplicateContractNameError && !duplicateContractNumberError
                                                    && contractNumber && isContractNumberValid && billingEntity && billingEntity !== 'Select'
                                                    && isContactNameValid && email && isValidEmail &&
                                                    gstNumber && companyName && panName && registeredStreetAddress &&
                                                    registeredStreetAddressLane2 &&
                                                    registeredCity && registeredStateProvince && registeredPostalCode &&
                                                    isValidGstNumber
                                                    //  && cinNumber 
                                                    && isCinValid && contactValidationsFunc()
                                                    ?
                                                    <img src={"./images/icons/CirclecircleWithTick.svg"} style={{ height: "16px" }} alt="ok" />
                                                    :
                                                    <>

                                                        {
                                                            index === 0 ?
                                                                <MdErrorOutline title="Please fill all the fields in this step" style={{ color: "orange" }} fontSize={18} />
                                                                :
                                                                null
                                                        }
                                                    </>
                                            }
                                            {
                                                index === 1 && billingStreetAddress && billingStreetAddressLane2 && billingCity &&
                                                    billingStateProvince && billingPostalCode && isPincodeValid && shippingStreetAddress && shippingStreetAddressLane2 && shippingCity
                                                    && shippingStateProvince && shippingPostalCode && isShippingPincodeValid
                                                    ?
                                                    <img src={"./images/icons/CirclecircleWithTick.svg"} style={{ height: "16px" }} alt="ok" />
                                                    :
                                                    <>

                                                        {
                                                            index === 1 ?
                                                                <MdErrorOutline title="Please fill all the fields in this step" style={{ color: "orange" }} fontSize={18} />
                                                                :
                                                                null
                                                        }
                                                    </>
                                            }
                                            {
                                                index === 2 && spaceName && isSpaceNameValid && contractStartDate && contractStartDate !== '' &&
                                                    contractEndDate && contractEndDate !== ''
                                                    && expireNotification &&
                                                    gracePeriod >= 0 && termsAndConditions && !slfValidationsFunc()
                                                    ?
                                                    <img src={"./images/icons/CirclecircleWithTick.svg"} style={{ height: "16px" }} alt="ok" />
                                                    :
                                                    <>

                                                        {
                                                            index === 2 ?
                                                                <MdErrorOutline title="Please fill all the fields in this step" style={{ color: "orange" }} fontSize={18} />
                                                                :
                                                                null
                                                        }
                                                    </>
                                            }
                                        </div>
                                        <span style={{ fontSize: "small", marginTop: "10px" }}>{item.description}</span>
                                        {
                                            checkmarkVisibilityCalculationPage2()
                                                ?
                                                null :
                                                <>
                                                    {
                                                        index === 0 ?
                                                            <spam style={{ fontSize: "10px", marginTop: "10px", color: "red" }}>
                                                                Missing Fields: <br />{missingFieldsCalculatePage2()}
                                                            </spam>
                                                            :
                                                            null
                                                    }
                                                </>
                                        }

                                        {
                                            checkmarkVisibilityCalculationPage3()
                                                ?
                                                null :
                                                <>
                                                    {
                                                        index === 1 ?
                                                            <spam style={{ fontSize: "10px", marginTop: "10px", color: "red" }}>
                                                                Missing Fields: <br />{missingFieldsCalculatePage3()}
                                                            </spam>
                                                            :
                                                            null
                                                    }
                                                </>
                                        }

                                        {
                                            checkmarkVisibilityCalculationPage4()
                                                ?
                                                null :
                                                <>
                                                    {
                                                        index === 2 ?
                                                            <spam style={{ fontSize: "10px", marginTop: "10px", color: "red" }}>
                                                                Missing Fields: <br />{missingFieldsCalculatePage4()}
                                                            </spam>
                                                            :
                                                            null
                                                    }
                                                </>
                                        }
                                    </div>
                                )
                            })

                            }

                        </div>
                    </div>

                    <div className="infoContainer">
                        <div>
                            {steps && steps.map((item, index) => {
                                return (
                                    <>
                                        {currentPage - 1 === index + 1 ?
                                            <div className="infoTitle">
                                                <h6 style={{ padding: "20px", lineHeight: "0px" }}>{item.name}</h6>
                                                <h6 style={{ padding: "20px", lineHeight: "0px" }}>{index + 1} of {steps.length}</h6>
                                            </div>

                                            : null}
                                    </>
                                )
                            })}
                        </div>

                        <div className="infoBody">
                            <div>
                                <h7 style={{ fontWeight: "bold" }}>Space</h7>
                                <div className="infoBodyInputs">
                                    <div className="responsiveInputSection">
                                        <div>
                                            <label className='add-facility-modal-label'>Space Name {<span style={{ color: "red" }}>*</span>}</label>
                                            <input disabled={viewClicked} type='text' value={spaceName}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    const trimmedValue = eleminateSpacesAtStartOfInputField(value);
                                                    // const regex = /^[a-zA-Z0-9.,/\-_ #&()~]*$/;
                                                    const regex = /^[a-zA-Z0-9.,/\-_ !@#$%^&*():;+=<>?{}[\]~]*$/;
                                                    if (regex.test(trimmedValue) || trimmedValue === '') {
                                                        if (trimmedValue.length !== 0 && (trimmedValue.length < 3 || trimmedValue.length > 200)) {
                                                            setIsSpaceNameValid(false);
                                                        } else {
                                                            setIsSpaceNameValid(true);
                                                        }
                                                        setSpaceName(trimmedValue);
                                                    }
                                                }}
                                                className='form-control responsive-add-facility-input-fields' />
                                            {!isSpaceNameValid &&
                                                <span className='input-error-text'>Must be min of 3 to max of 200 characters</span>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr></hr>
                            <div>
                                <h7 style={{ fontWeight: "bold" }}>Contract Information</h7>
                                <div className="infoBodyInputs">
                                    <div className="responsiveInputSection">
                                        <div >
                                            <label className='add-facility-modal-label'>Contract Start Date {<span style={{ color: "red" }}>*</span>}</label>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    label=""
                                                    disabled={viewClicked || contractStatus === 'active'}
                                                    value={dayjs(contractStartDate)}
                                                    views={['day', 'month', 'year']}
                                                    format={localStorage.getItem("date_format")}
                                                    // maxDate={dayjs(contractEndDate)} 
                                                    // maxDate={dayjs('2025-01-08')} 
                                                    onChange={(e) => {
                                                        const newStartDate = e.format('YYYY-MM-DD');
                                                        if (newStartDate === "") {
                                                            setContractEndDate("")
                                                        }
                                                        setContractStartDate(newStartDate)
                                                        if (newStartDate && contractEndDate && dayjs(newStartDate) >= dayjs(contractEndDate)) {
                                                            setDateError('End date should be after the start date.')
                                                        } else {
                                                            setDateError("")
                                                        }
                                                        let newLicenseTableBodyRows = [...licenseTableBodyRows]
                                                        newLicenseTableBodyRows[0].rate_start_date = newStartDate
                                                        setLicenseTableBodyRows(newLicenseTableBodyRows)
                                                        setSlfTableError(licenseFeeDateValidationByStartDateEndDate(newLicenseTableBodyRows, newStartDate, contractEndDate))
                                                    }
                                                    }
                                                    sx={{
                                                        '.MuiInputBase-root': {
                                                            height: '40px', // Adjust height
                                                            backgroundColor: 'white', // Set background to white
                                                            borderRadius: '6px', // Optional: Rounded corners
                                                            fontSize: '16px', // Optional: Adjust text size
                                                            width: "250px"
                                                        },
                                                    }}
                                                    // slotProps={{
                                                    //     textField: {
                                                    //         InputProps: {
                                                    //             readOnly: true, // Prevent typing in the input field
                                                    //         },
                                                    //         onKeyDown: (e) => e.preventDefault(), // Block keyboard inputs
                                                    //     },
                                                    // }}
                                                    className='form-control responsive-add-facility-input-fields'
                                                />
                                            </LocalizationProvider>

                                            <p className="input-error-text">{dateError}</p>
                                        </div>
                                        <div >
                                            <label className='add-facility-modal-label'>Contract End Date {<span style={{ color: "red" }}>*</span>}</label>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    label=""
                                                    disabled={viewClicked || contractStartDate === ''}
                                                    value={dayjs(contractEndDate)}
                                                    views={['day', 'month', 'year']}
                                                    format={localStorage.getItem("date_format")}
                                                    minDate={dayjs(contractStartDate)} 
                                                    onChange={(e) => {
                                                        setContractEndDate(e.format('YYYY-MM-DD'))
                                                        if (e.format('YYYY-MM-DD') === "") {
                                                            setLicenseTableBodyRows([{
                                                                serial_number: 1,
                                                                area_in_sqft: "",
                                                                cost_per_unit: "",
                                                                rate_start_date: contractStartDate,
                                                                rate_end_date: contractEndDate,
                                                                license_fee: ""
                                                            }])
                                                        }
                                                        let newLicenseTableBodyRows = [...licenseTableBodyRows]
                                                        newLicenseTableBodyRows[licenseTableBodyRows.length - 1].rate_end_date = e.format('YYYY-MM-DD')
                                                        setLicenseTableBodyRows(newLicenseTableBodyRows)
                                                        setSlfTableError(licenseFeeDateValidationByStartDateEndDate(newLicenseTableBodyRows, contractStartDate, e.format('YYYY-MM-DD')))
                                                        if (contractEndDate >= new Date(contractEndDate)) {
                                                            setDateError('End date should be after the start date.')
                                                        } else {
                                                            setDateError("")
                                                        }
                                                    }
                                                    }
                                                    sx={{
                                                        '.MuiInputBase-root': {
                                                            height: '40px', // Adjust height
                                                            backgroundColor: 'white', // Set background to white
                                                            borderRadius: '6px', // Optional: Rounded corners
                                                            fontSize: '16px', // Optional: Adjust text size
                                                        },
                                                    }}
                                                    // slotProps={{
                                                    //     textField: {
                                                    //         InputProps: {
                                                    //             readOnly: true, // Prevent typing in the input field
                                                    //         },
                                                    //         onKeyDown: (e) => e.preventDefault(), // Block keyboard inputs
                                                    //     },
                                                    // }}
                                                    className='form-control responsive-add-facility-input-fields'
                                                />
                                            </LocalizationProvider>
                                        </div>
                                        <div >
                                            <label className='add-facility-modal-label'>Send Expiry Notification Before {<span style={{ color: "red" }}>*</span>}</label>
                                            <select disabled={viewClicked} value={expireNotification} onChange={(e) => setExpireNotification(e.target.value)} className='form-select responsive-add-facility-input-fields'>
                                                <option hidden>Select</option>
                                                <option value="1 month">1 Month</option>
                                                <option value="2 months">2 Months</option>
                                                <option value="3 months">3 Months</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="responsiveInputSection">
                                        <div>
                                            <label className='add-facility-modal-label'>Payment Time (Max 90 days) {<span style={{ color: "red" }}>*</span>}</label>
                                            <input type='number' disabled={viewClicked} className='form-control responsive-add-facility-input-fields'
                                                value={gracePeriod}
                                                onWheel={(e) => e.target.blur()}
                                                onChange={(e) => {
                                                    const input = e.target.value;
                                                    const formattedInput = input.replace(/[^\d]+|(?<=\..*)\./g, '');
                                                    if (formattedInput <= 90) {
                                                        setGracePeriod(parseInt(formattedInput));
                                                    }
                                                }} />
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <hr></hr>

                            <div>
                                <div style={{ display: "flex", justifyContent: "space-between", }}>
                                    <h7 style={{ fontWeight: "bold", marginBottom: "10px" }}>FMS Rates</h7>
                                </div>
                                {slfTableError?.error && 
                                <div style={{margin:"0px 0px 10px 0px", background:"rgba(255, 0, 0, 0.1)", border:"1.5px solid red", borderRadius:"8px", padding:"10px"}}>
                                    <MdErrorOutline style={{color:"red"}} fontSize={18} /> <span className='input-error-text'>{slfTableError.message}</span>
                                </div>
                                    }
                                {contractStartDate && contractEndDate && contractStartDate !== '' && contractEndDate !== ''?
                                <div className="infoBodyInputs">
                                    <div className='license_fee_details_table'>
                                        <table>
                                            <thead className='fin_man_table_head commercial-head-table text-center'>
                                                <tr>
                                                    <th>S.No</th>
                                                    <th>Begin Date<span style={{ color: "red" }}>*</span> </th>
                                                    <th>End Date <span style={{ color: "red" }}>*</span></th>
                                                    <th style={{ textWrap: "nowrap" }}>Area (sq. ft)</th>
                                                    <th style={{ textWrap: "nowrap" }}>Cost / Unit (<span>{formatCurrencyBasedOnRegion()}</span>)</th>
                                                    <th style={{ textWrap: "nowrap" }}>License Fee (<span>{formatCurrencyBasedOnRegion()}</span>)<span style={{ color: "red" }}>*</span></th>
                                                </tr>

                                                </thead>
                                                <tbody className='fin_man_table_body'>
                                                    {licenseTableBodyRows.length > 0 && licenseTableBodyRows.map((item, index) => (
                                                        <>
                                                            <tr >
                                                                <td className="table_text_right">{index + 1}</td>
                                                                <td><input type="date" value={item.rate_start_date}
                                                                    min={index === 0 ? contractStartDate : item.rate_start_date}
                                                                    onChange={(e) => {
                                                                        const input = e.target.value;
                                                                        let newObj = licenseTableBodyRows;
                                                                        newObj[index].rate_start_date = input
                                                                        if (input > newObj[index].rate_end_date) {
                                                                            newObj[index].rate_end_date = ""
                                                                        }
                                                                        setLicenseTableBodyRows([...newObj])
                                                                        setSlfTableError(licenseFeeDateValidationByStartDateEndDate(newObj, contractStartDate, contractEndDate))
                                                                    }}
                                                                    onKeyDown={(e) => e.preventDefault()}
                                                                    disabled={viewClicked || true}
                                                                    className='form-control noSpinArrows' /></td>

                                                                <td><input type="date" value={item.rate_end_date}
                                                                    min={item.rate_start_date !== "" ? new Date(new Date(item.rate_start_date).setDate(new Date(item.rate_start_date).getDate() + 1)).toISOString().slice(0, 10) : item.rate_start_date}
                                                                    max={contractEndDate}
                                                                    onChange={(e) => {
                                                                        const input = e.target.value;
                                                                        let newObj = licenseTableBodyRows;
                                                                        if (index < licenseTableBodyRows.length - 1) {
                                                                            let date = new Date(input);
                                                                            date.setDate(date.getDate() + 1);
                                                                            date = date.toISOString('yyyy-mm-dd').slice(0, 10);
                                                                            newObj[index + 1].rate_start_date = date;
                                                                        }
                                                                        newObj[index].rate_end_date = input
                                                                        setLicenseTableBodyRows([...newObj])
                                                                        setSlfTableError(licenseFeeDateValidationByStartDateEndDate(newObj, contractStartDate, contractEndDate))
                                                                    }}
                                                                    onKeyDown={(e) => e.preventDefault()}
                                                                    // disabled={new Date(item.rate_end_date) < finalTodayDate || viewClicked}
                                                                    disabled={viewClicked}
                                                                    className='form-control noSpinArrows' /></td>

                                                                <td><input type="number" value={item.area_in_sqft}
                                                                    onChange={(e) => {
                                                                        const input = limitCurrencyAmount(e.target.value, 1000000000.00);
                                                                        const formattedInput = parseInt(input);
                                                                        let newObj = [...licenseTableBodyRows];
                                                                        newObj[index].area_in_sqft = parseInt(formattedInput)
                                                                        setLicenseTableBodyRows([...newObj])
                                                                    }}
                                                                    onWheel={(e) => e.target.blur()}

                                                                    disabled={viewClicked}
                                                                    className='form-control noSpinArrows'
                                                                /></td>
                                                                <td>
                                                                    <input type="number"
                                                                        value={item.cost_per_unit}
                                                                        onChange={(e) => {
                                                                            const input = limitCurrencyAmount(e.target.value, 1000000000.00);
                                                                            const formattedInput = formatNumericparseFloatInput(input);
                                                                            const limitedDecimals = formattedInput
                                                                                ? parseFloat(formattedInput).toFixed(2)
                                                                                : '';
                                                                            let newObj = licenseTableBodyRows;
                                                                            newObj[index].cost_per_unit = parseFloat(limitedDecimals)
                                                                            newObj[index].license_fee = parseFloat(item.area_in_sqft * item.cost_per_unit).toFixed(2)
                                                                            setLicenseTableBodyRows([...newObj])
                                                                        }}
                                                                        onWheel={(e) => e.target.blur()}

                                                                        disabled={viewClicked}
                                                                        className='form-control noSpinArrows' />
                                                                </td>

                                                                <td><input type="number"
                                                                    value={item.license_fee}
                                                                    onChange={(e) => {
                                                                        const input = limitCurrencyAmount(e.target.value, 1000000000.00);
                                                                        const formattedInput = formatNumericparseFloatInput(input);
                                                                        let newObj = [...licenseTableBodyRows];
                                                                        newObj[index].license_fee = formattedInput;
                                                                        setLicenseTableBodyRows([...newObj]);
                                                                    }}
                                                                    onWheel={(e) => e.target.blur()}
                                                                    disabled={viewClicked}
                                                                    className='form-control noSpinArrows'
                                                                /></td>

                                                            </tr>


                                                        </>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        {
                                            !viewClicked ?

                                                <div style={{ display: "flex", justifyContent: "end", marginTop: "10px" }}>
                                                    {
                                                        contractEndDate !== licenseTableBodyRows[licenseTableBodyRows.length - 1].rate_end_date ?
                                                            <img style={{ height: "18px", marginRight: "10px" }}
                                                                onClick={handleAddLicenseFeeRow}
                                                                src="./images/icons/PlusaddItem.svg" alt="add"
                                                                title="Add row below"
                                                            /> : null
                                                    }
                                                    {
                                                        licenseTableBodyRows.length >= 2 ?
                                                            <img style={{ height: "18px" }} src="./images/icons/MinusremoveItem.svg"
                                                                onClick={() => handleRemoveLicenseFeeRow(licenseTableBodyRows.length - 1)}
                                                                alt="remove"
                                                                title="Delete last row"
                                                            /> : null
                                                    }

                                                </div> :
                                                null}
                                    </div>
                                    :
                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>
                                        <span className='input-error-text'>Please select the contract start date and end date</span>
                                    </div>
                                }
                            </div>
                            <hr></hr>
                            <div>
                                <label >Terms and Conditions {<span style={{ color: "red" }}>*</span>}</label>
                                <UploadComponent
                                    onFilesSelected={handleSelectTermsAndCondition}
                                    idType={"termsandconditions"}
                                    uploadActionClicked={handleTermsAndConditionsUpload}
                                    uploadMethod={"single"}
                                    viewMode={viewClicked}
                                    maxNumberOfFiles={1}
                                    uploadedFileData={termsAndConditions ? [{ file_name: termsAndConditions?.split("/")[2]?.split("-")[0], file_type: termsAndConditions?.split("/")[2]?.split(".")[1], s3_key: termsAndConditions }] : []}
                                    acceptedFileTypes={".pdf"}
                                />
                            </div>
                            <hr></hr>

                            <div className="infoBodyInputs">
                                <div className="responsiveInputSection" >

                                    <UploadComponent
                                        onFilesSelected={handleFilesSelected}
                                        uploadMethod="single"
                                        viewMode={viewClicked}
                                        uploadedFileData={commercialHeadGetDocumentsForContract}
                                        uploadActionClicked={handleDocumentUpload}
                                        deleteSpecificFileMain={confirmDeleteDocument}
                                        maxNumberOfFiles={5}
                                        handleErrorFromDocument={handleErrorFromDocument}
                                        idType={"contract"}
                                        acceptedFileTypes={".pdf, .jpeg, .jpg, .png"}

                                    />

                                </div>


                            </div>

                        </div>
                        <div className="infoFotter">
                            {!viewClicked ?
                                <>
                                     {currentPage <steps.length + 2 && (
                                        <button className="infoNextBtn secondary-button" style={{ marginRight: "20px" }} onClick={handleShowCloseConfirmationModal}>Close</button>
                                    )}
                                    <button className="infoNextBtn secondary-button" 
                                    // disabled={(editCompleteContractClicked ? true : false)}
                                        style={{ marginRight: "20px", opacity: '100%' }} onClick={changePagePrev}>Back</button>

                                    {
                                        !editCompleteContractClicked ?
                                            <button className="infoNextBtn primary-button" onClick={ finalSave }
                                                style={checkSaveandContinueValidation() ? { opacity: '50%' } : { opacity: '100%' }}
                                                disabled={checkSaveandContinueValidation()}
                                            >{"Save" }</button> :
                                            <button className="infoNextBtn primary-button" onClick={handleSubmit}> Submit</button>
                                    }
                                </>
                                :
                                <>
                                    {currentPage < steps.length + 1 ? <button className="infoNextBtn secondary-button" style={{ marginRight: "20px" }} onClick={() => closeClicked()} >Close</button> : null}
                                    <button className="infoNextBtn secondary-button" style={{ marginRight: "20px" }} onClick={changePagePrev}>Back</button>
                                    <button className="infoNextBtn primary-button" style={{ marginRight: "20px" }} onClick={() => changePageNext()} >{currentPage === steps.length + 1 ? "Close" : "Next"}</button>
                                </>
                            }
                        </div>
                        <Modal
                            backdrop="static"
                            show={showCloseConfirmationModal} onHide={handleCloseCloseConfirmationModal}
                            centered className="popper-modal">
                            <Modal.Body className="text-center">
                                <h5>Are you sure you want to Close?</h5>
                            </Modal.Body>
                            <Modal.Footer className="footer">
                                <Button variant="secondary" className="confirmation" onClick={handleCloseCloseConfirmationModal}>  Cancel </Button>
                                <Button variant="secondary" className="confirmation-left" onClick={handleCloseProceed} > Proceed</Button>
                            </Modal.Footer></Modal>
                        {/*modal for confirmation*/}
                        < Modal show={showConfirmationModal} onHide={handleCloseConfirmationModal} centered className="popper-modal" >
                            <Modal.Body className="text-center" ><h5>Are you sure you want to save this as Draft?</h5></Modal.Body>
                            <Modal.Footer className="footer">
                                <Button variant="secondary" className="confirmation" onClick={handleCloseConfirmationModal}>Cancel</Button>
                                <Button variant="secondary" className="confirmation-left" onClick={handleSaveAsDraftConfirmation}>Proceed</Button>
                            </Modal.Footer>
                        </Modal>
                    </div>
                </div>
                :
                null

            }

            {isLoading ? <Loader /> : null}
            {paginationLoader ? <Loader /> : null}
            {contractApiLoader ? <Loader /> : null}
            <Footer />
        </>
    )
}